var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpill2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268.84 299.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ee396e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270,349.12a6.17,6.17,0,0,0,1.28.65,3.61,3.61,0,0,1,.66.58,4.51,4.51,0,0,0,1.69,1.93.92.92,0,0,1,.34,1.18,1.92,1.92,0,0,0,.13,1.62,1.65,1.65,0,0,1-.33,2.07,1.56,1.56,0,0,0-.47,1.54c.06.44-.14.65-.59.79a7.87,7.87,0,0,0-2.37,1,1.11,1.11,0,0,1-1.57.06l-.06-.06a1.31,1.31,0,0,0-1.54-.28c-1,.53-1.08.47-1.57-.67l-.52-1.22c-.09-.23-.2-.48-.49-.5-.61-.05-.83-.57-1.05-1a5.9,5.9,0,0,0-1.16-1.63c-.43-.41,0-1.32-.38-2-.13-.2-.1-.49-.19-.72-.17-.4-.82-.52-.79-1s.76-.18,1-.52a2.3,2.3,0,0,0,.41-.62,2.17,2.17,0,0,1,1.91-1.35,7.56,7.56,0,0,0,2.34-.61A2.91,2.91,0,0,1,270,349.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.69,421.42a3.75,3.75,0,0,1,.82,1.22,6.28,6.28,0,0,1-.11,5.11,5.74,5.74,0,0,1-5.13,3.53,11.53,11.53,0,0,1-4.22-.87c-1.31-.55-2.38-1.41-2.25-3.08v-.9c.08-.71.11-1.27.19-1.83a3.78,3.78,0,0,1,2.16-3.1c.74-.34,1.39-.85,2.12-1.21a4.51,4.51,0,0,1,3.62-.46A7.44,7.44,0,0,1,228.69,421.42Z",
    transform: "translate(-154.83 -222.21)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.73,410.94a10.69,10.69,0,0,1,2.47-3.51,2.76,2.76,0,0,1,2.67-.91,1.52,1.52,0,0,1,.51-.12c1.43.38,3,.42,3.87,2,.94.28,1.09,1.16,1.36,1.89a6.47,6.47,0,0,1,0,4.08,3.59,3.59,0,0,1-3.12,2.85,6.3,6.3,0,0,0-2.54.4.45.45,0,0,1-.36,0c-.79-.44-1.83-.5-2.18-1.6-.12-.38-.56-.65-.86-1a8.67,8.67,0,0,1-1.89-2.79A1.65,1.65,0,0,1,260.73,410.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.2,426.8a9.28,9.28,0,0,1,1.41-1.25,3.19,3.19,0,0,1,4,.14,3.23,3.23,0,0,0,1.29.59c.7.64,1.28,1.22,1.84,1.81.12.12.32.29.3.43-.12,1.26.23,2.52-.79,3.71a6.09,6.09,0,0,1-4.84,2,2,2,0,0,1-.88-.28,5.75,5.75,0,0,1-3.06-4.24A3.16,3.16,0,0,1,231.2,426.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.33,337.77c-.23.13-.49.19-.51-.23s-.39-.61-.63-.89a1.44,1.44,0,0,1-.44-1c.1-1.24,0-2.53,1.12-3.47a.89.89,0,0,0,.21-1,5.69,5.69,0,0,1,.35-3.48,1.7,1.7,0,0,1,2-1.29,2.3,2.3,0,0,1,.34.12,1.26,1.26,0,0,1,1,1,11.75,11.75,0,0,1,.52,2.56,5.46,5.46,0,0,1-.68,1.72c-.23.58-.16.69.35.84.79.23,1.58.43,2.36.66a.58.58,0,0,1,.48.66.48.48,0,0,1-.07.2c-.28.63-.62,1.23-.87,1.86a1.85,1.85,0,0,1-2.15,1.4.8.8,0,0,0-.9.48c-.21.35-.53.53-1,.12A1.11,1.11,0,0,0,338.33,337.77Z",
    transform: "translate(-154.83 -222.21)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.14,377.7h.09c-.12.51-.13,1-.66.94l-.16.18c-.63,0-.82-.73-1.56-.54h0a.27.27,0,0,1,.08.07c-.59.33-1.08.36-1.34-.16a.61.61,0,0,1-.26-.12l-.7-.56h-.1l.06.11a3,3,0,0,1-.9-.07,1.07,1.07,0,0,0-.19.18,4.78,4.78,0,0,1-1.08.49l.07.09c-.56.26-.65.24-.59-.25a1,1,0,0,1-.14-.22,2.11,2.11,0,0,1-.21-.31v.12c-.44-.53-.27-1.37-1.09-1.58,0,0-.08-.09-.11-.14a.53.53,0,0,1,.08-.67.47.47,0,0,1,.65-.12c.33.21.52.63,1,.74a1.15,1.15,0,0,1,.12-.25c.85,0,1.22-.39,1.24-1a5.6,5.6,0,0,1,1.83-3.8,8.74,8.74,0,0,1,4-1.9,3.76,3.76,0,0,1,1.11.14,1,1,0,0,1,.87,1.08c-.12.81.39,1.64,0,2.41s.33,1.73,0,2.58c0,.05-.05.11-.15.27h.06a24.17,24.17,0,0,1-1.52,2.07.23.23,0,0,1-.25,0l-.07.1-.08.09Z",
    transform: "translate(-154.83 -222.21)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246,317.16a4.9,4.9,0,0,0,1.38,1.75,5.56,5.56,0,0,1,1.87,2.07c.43.74.73,1.61,1.78,1.74.13,0,.2.39,0,.42-.63.08-.79.52-1,1a4.71,4.71,0,0,1-.56,1.38,3.14,3.14,0,0,1-4.08.72,7.61,7.61,0,0,1-2.75-2.77,3.07,3.07,0,0,1-.43-2.34,8.08,8.08,0,0,1,.94-2.79A10.55,10.55,0,0,1,244.4,317a.93.93,0,0,1,1.31-.21A1,1,0,0,1,246,317.16Z",
    transform: "translate(-154.83 -222.21)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.56,358.63c.17.27.3.56.47.82,1.34,2,1.35,3.28-.08,5.12a4.3,4.3,0,0,0-.95,2.22,5,5,0,0,1-.13.93,1.31,1.31,0,0,1-1.23.72,2.4,2.4,0,0,1-1.78-2.14,1.67,1.67,0,0,0-.6-1.66,8.3,8.3,0,0,1-.64-.69,3.77,3.77,0,0,1-1.05-4,1.36,1.36,0,0,1,.09-.51,2.5,2.5,0,0,1,.3-.64c1.19-1.16,2.71-1.2,4.22-1.12A1.9,1.9,0,0,1,250.56,358.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.2,300.76c.6.37,1.13.77,1.68.48a1,1,0,0,1,1.41.13.92.92,0,0,1,.16.27,1.69,1.69,0,0,0,.77.51c.92.32,1.27,1.2,1.79,1.88a1.9,1.9,0,0,1-.34,2.27,1.51,1.51,0,0,1-2,.46,2.45,2.45,0,0,0-.54-.18c-.58.83-1.45,1.41-1.8,2.4a.51.51,0,0,1-.72.13.39.39,0,0,1-.1-.08,28.94,28.94,0,0,1-2.44-3.08,4.72,4.72,0,0,1-.45-1c-.29-1.28-.3-2.5.9-3.4.3-.23.56-.5.86-.73A.76.76,0,0,1,270.2,300.76Z",
    transform: "translate(-154.83 -222.21)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.53,417c1.28-1.12,2.15-1.26,3.66-.37.33.19.69.3,1.13.55a3.23,3.23,0,0,1,1.14,3.16,5.23,5.23,0,0,0,0,.56,2.52,2.52,0,0,1-1,1.94c-.62.41-1.26.8-1.92,1.15a2.38,2.38,0,0,1-2.17.17,6.6,6.6,0,0,1-2.08-1.25,1.34,1.34,0,0,1-.47-1A5.54,5.54,0,0,1,236.53,417Z",
    transform: "translate(-154.83 -222.21)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.36,421.74h-.08c0-.15,0-.22.12-.28a.87.87,0,0,1-.11-.18c0-.52.24-.72.57-.63s.26.37.21.62a.54.54,0,0,1-.11.23h.1a.34.34,0,0,1,0,.2l.17.07a2.36,2.36,0,0,1,1.87,1,2.2,2.2,0,0,0,2.45.88c1-.21,1.69.58,2.46,1,.15.78-.63,1-.92,1.52a7.21,7.21,0,0,1-.64.92.54.54,0,0,1-.67.17c-.28-.13-.56-.28-.83-.44a.75.75,0,0,0-1,.12c-.42.38-.81.78-1.24,1.15-1,.9-3.31,1-4.18.13a2.93,2.93,0,0,1-.92-3.07A5.77,5.77,0,0,1,261.36,421.74Z",
    transform: "translate(-154.83 -222.21)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.45,400.63a5.23,5.23,0,0,1,2.65-.65,3.33,3.33,0,0,1,3.31,3l.05.18A3,3,0,0,1,215,406.8c-.44.23-.93.38-1.51.61a1.86,1.86,0,0,1-1.86-.45,12,12,0,0,0-2.23-1.7,1.8,1.8,0,0,1-.79-1.78A3.19,3.19,0,0,1,210.45,400.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305,422.58a9,9,0,0,1-1,.71,1.54,1.54,0,0,1-1.26.13c-1.94-.57-2.19-.94-1.81-2.92.06-.31.29-.58.32-.88.08-1,.77-1.38,1.48-1.8a1.27,1.27,0,0,1,1.42,0c.32.2.62.43.94.63a2.76,2.76,0,0,0,2.32.36c1.3-.37,1.85,0,2.2,1.29.08.3.07.62.16,1h0l.06-.08c1,.27,1.6-.51,2.42-.46.18,0,.42-.48.58-.21.32.49-.33.3-.47.5a3.58,3.58,0,0,0-.24.48c-.17.41-.31.83-.51,1.21a.89.89,0,0,1-1.21.39l-.08,0c-.31-.16-.51-.55-.89-.66a1.35,1.35,0,0,1-.33.19c-.9.59-1.68.8-2.53,0l-.11-.06.05.08a1.41,1.41,0,0,0-1.15-.14A1.59,1.59,0,0,0,305,422.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.2,291.26a3,3,0,0,1,0,1.62,2.49,2.49,0,0,1-1.59,2.14.85.85,0,0,1-.71.14A3.8,3.8,0,0,1,301,294a5.71,5.71,0,0,1-1.11-4.24c.12-.89.31-1.75,1.41-2,.15,0,.25-.25.38-.37.61-.54.61-.51,1.23,0A5.15,5.15,0,0,1,305.2,291.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.42,399.06a5.47,5.47,0,0,1,.21-3.3c.06-.21.32-.38.52-.52a12.8,12.8,0,0,1,1.11-.69,2,2,0,0,1,1.79,0c.89.32,1.34,1.1,2,1.64,1,.8,1,1.26.29,2.68a18.76,18.76,0,0,1-1.4,1.42,3,3,0,0,1-4.19-.66A3.25,3.25,0,0,1,362.42,399.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.11,403.89c1.08,0,2.29,1.78,1.4,2.83a4.35,4.35,0,0,0-.91,2,3.44,3.44,0,0,1-2.19,2.63,2.1,2.1,0,0,1-2.72-1.19,2.47,2.47,0,0,1-.11-.36c-.1-.55-.22-1.1-.32-1.77a3.71,3.71,0,0,1,1.9-1.92,2.62,2.62,0,0,0,1.56-1.48A1.28,1.28,0,0,1,246.11,403.89Z",
    transform: "translate(-154.83 -222.21)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312,407c-1-.09-1.55.08-1.62,1.14a.49.49,0,0,1-.1.15.68.68,0,0,1-.68.19.52.52,0,0,1-.4-.55,1.18,1.18,0,0,1,.26-.87c.22-.25.37-.54.18-.84-.7-1.07-.45-2.16-.15-3.4h0l-.1.08c-.37-.08-.63-.11-.95-.19a.19.19,0,0,1-.08.1.63.63,0,0,1-.53-.11.19.19,0,0,0-.17.07,1.61,1.61,0,0,1-1.64-1.56,1.27,1.27,0,0,1,0-.2c0-.37.26-.63.56-.48.83.38,1.67.74,2.46,1.2a2,2,0,0,0,.86.19l.26-.22c.4-.39.71-.68,1.09-1.09h-.14a5.66,5.66,0,0,1-.44-.75l-.16.07c-1.52.07-1.58.06-2.65-.73-.24-.17-.32-.51-.15-.62a.41.41,0,0,1,.51,0c.19.15.37.5.58.37.7-.42,1.26.27,2,.31l.08-.24c.51-.31.89-.25.85.26a1,1,0,0,0,.78,1.18h.05a.65.65,0,0,1,.39.28l.35.11a7.4,7.4,0,0,1,.92.26V401c.21-.43.31-.91.8-.46a4.8,4.8,0,0,1,.78.78.41.41,0,0,1-.09.57l-.09,0a2.19,2.19,0,0,1-.68.17v.14a11.68,11.68,0,0,0,.4,1.13h0c.55.38.58.44.07.58l-.09.28c-.19.47-.41.78-.53,1.13A2.51,2.51,0,0,1,312,407Z",
    transform: "translate(-154.83 -222.21)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.2,412.06a6.84,6.84,0,0,1-.74-.56,2.54,2.54,0,0,1-.8-2.7,5,5,0,0,1,2.82-3.29c.17-.1.48,0,.82.15s.43.4.65.58a3.33,3.33,0,0,1,1.09,4.59,2.78,2.78,0,0,1-.29.41C329.74,412.63,328.7,412.91,327.2,412.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335,356.54c.48.73.86,1.37,1.3,2.16l.05-.06a2.3,2.3,0,0,1,.34.66h.28a2.39,2.39,0,0,0,.56-.32h-.05a1.66,1.66,0,0,1,1.9-.13c.19.1.38.26.14.48l.14.23a11.92,11.92,0,0,1-.09,1.46h0c-.08.43,0,.87-.31,1a1.27,1.27,0,0,1-.25.27,5.68,5.68,0,0,1-1,.27h0l.07.05c-.41.4-.94.57-1.18,1a1.77,1.77,0,0,1,0,.46c.06,1.06-.57,1.59-1.27,2.27h.1a7.17,7.17,0,0,1-1.34.64c-.26.09-.53.07-.61-.19l-.27-.06a3.72,3.72,0,0,1-.48-.27.23.23,0,0,1-.1.12c-.57.37-.23.89-.47,1.26a.58.58,0,0,1-.79.22l-.14-.11a.64.64,0,0,1-.08-.9.58.58,0,0,1,.21-.17c.35-.2.8-.25.95-.74a.92.92,0,0,1-.13-.21,3.72,3.72,0,0,1-.19-1.75,2.6,2.6,0,0,0-.84-2.23h0v.13c-.33-.33-.52-.64-.26-.94v-.33l-.23-1.37h0v.12c-.21-.61-.39-1.16,0-1.48l.11-.37v-.52c-.41-.7-.83-.39-1.23-.28s-.59-.12-.65-.46a3.05,3.05,0,0,1,0-.74.57.57,0,0,1,.45-.53.66.66,0,0,1,.67.2c.16.18.23.44.4.61a.67.67,0,0,0,.49.15,1,1,0,0,1,.24-.21,1.73,1.73,0,0,1,.31-.35l.27-.09h-.32a1.47,1.47,0,0,1,1.63-.36h.24a.62.62,0,0,0,.51-.41,2.08,2.08,0,0,1,.28-.48.34.34,0,0,1,.48,0l0,0a.77.77,0,0,1,.26.46.69.69,0,0,1-.17.51.75.75,0,0,0-.17.76A2.32,2.32,0,0,1,335,356.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.49,389.51a9.23,9.23,0,0,1-.47-2,.82.82,0,0,1,.17-.5,4.11,4.11,0,0,1,3.6-1.93,3.43,3.43,0,0,1,2.53,1.36c.55.55.15,1.3-.05,2a2.67,2.67,0,0,1-.57,1.3,17.43,17.43,0,0,1-2.32,1.07,2.07,2.07,0,0,1-2.76-1A2.26,2.26,0,0,1,383.49,389.51Z",
    transform: "translate(-154.83 -222.21)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.84,336.49c.87,1.79,1.14,1.64-.36,3.47a2.21,2.21,0,0,1-2.65.79,5.42,5.42,0,0,1-.93-.55,3.52,3.52,0,0,1-1.59-3,2.34,2.34,0,0,1,1.79-2.53A3.1,3.1,0,0,1,165.84,336.49Z",
    transform: "translate(-154.83 -222.21)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.54,362.78c.12-.44.2-.77.58-.81s.67.09.92,0c.82-.43,1.43.16,2.13.32,1,.23.83,1.09.94,1.8a2.42,2.42,0,0,0,.12.35,3,3,0,0,1-2.31,3.56,3.18,3.18,0,0,1-1.19,0,1.08,1.08,0,0,1-.47-.28,10.1,10.1,0,0,1-.84-1c-1.17-1.65-1.17-1.65-.09-3.43A2.57,2.57,0,0,0,277.54,362.78Z",
    transform: "translate(-154.83 -222.21)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.36,329.35c.25.43.52.85.73,1.3a2.16,2.16,0,0,1-1,2.87,2.09,2.09,0,0,1-.35.13,3.72,3.72,0,0,1-4.36-2.94,3.85,3.85,0,0,1,0-1.22,1.08,1.08,0,0,1,.64-.86c.29-.13.58-.24,1-.39C191.75,327.63,192.56,328,193.36,329.35Z",
    transform: "translate(-154.83 -222.21)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.72,416.24h.1c-.42.44-.52.46-.67,0a1.43,1.43,0,0,1-.28-.07c-.27-.05-.43-.07-.72-.1H309l.16.11a1.1,1.1,0,0,1-1,0,4.48,4.48,0,0,0-1.15-.27.85.85,0,0,1-.25.17c-.61.24-.91-.13-1.29-.29-.61-.27-1.05-.63-.89-1.37s-.5-.77-.79-1.33h0v.13a2.07,2.07,0,0,1-.22-1.5c0-.23.15-.43.4-.35l.17-.25a2.32,2.32,0,0,1,1.88.11v-.09a1.16,1.16,0,0,0,.81-.21c.16-.12.33-.22.49-.16a1.15,1.15,0,0,1,.23-.1,1.43,1.43,0,0,0,.2-.23h0a1.4,1.4,0,0,1,1.66-.93c.63.15,1.34.25,1.7.8.11,0,.22.1.33.14a3,3,0,0,1,1.39,1.23h0c.28.25.62.32.54.64l.16.17a.37.37,0,0,1-.13.37h.11c-.18.33-.37.53-.64.55l-.16.24A5.31,5.31,0,0,1,310.72,416.24Z",
    transform: "translate(-154.83 -222.21)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.92,466.63c.41.31.41.75.4,1.33a3.15,3.15,0,0,1-1.69,2.89,3.25,3.25,0,0,1-2.91.17,1.29,1.29,0,0,1-.89-.89,4.08,4.08,0,0,1,.08-2.42,4.34,4.34,0,0,1,2.61-2.3c.94-.35,1.43.59,2.08,1A2.27,2.27,0,0,1,229.92,466.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.07,461.47a2.24,2.24,0,0,1,2.62.22,2,2,0,0,1,.93,2.26c-.32,1.9-1.34,2.85-3.5,3.07a2.41,2.41,0,0,1-1.92-1.57,2.91,2.91,0,0,1,1.35-3.68C238.75,461.63,238.91,461.58,239.07,461.47Z",
    transform: "translate(-154.83 -222.21)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.67,381a1.09,1.09,0,0,1,.85.34,1.82,1.82,0,0,1,.46,1.75,1.58,1.58,0,0,1-1.31,1.2,1.67,1.67,0,0,1-1.46-.14c-.6-.55-1-.28-1.43.16a1.9,1.9,0,0,1-.45.34,1.47,1.47,0,0,1-2.05-.33,2.28,2.28,0,0,1-.17-.3,4.26,4.26,0,0,1-.39-1.19,8.49,8.49,0,0,1,.36-1,1.25,1.25,0,0,1,1-.69,1.64,1.64,0,0,1,1.85.51c.1.13.32.17.47.25C237.7,381.13,238,381,238.67,381Z",
    transform: "translate(-154.83 -222.21)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.2,336.38a3.73,3.73,0,0,0,.67-2.44c.05-1.51,1-2.62,1.73-3.86a.6.6,0,0,1,.84-.11.58.58,0,0,1,.16.19c.27.46.25,1.12,1,1.22.08,0,.19.19.19.28,0,.81.57,1.53.28,2.51-.6.79-1.18,1.49-2.14,1.43a1.66,1.66,0,0,0-1.92,1.06.23.23,0,0,1-.15.12.42.42,0,0,1-.5-.07C382.2,336.63,382.14,336.44,382.2,336.38Z",
    transform: "translate(-154.83 -222.21)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.56,397.63c-.84.38-2.12.13-2.24,1.56,0,.08-.18.19-.29.2a3.79,3.79,0,0,1-2.55-.2,1.35,1.35,0,0,1-.74-.81,14.39,14.39,0,0,1-.3-1.84,1.09,1.09,0,0,1,.37-.83,2.49,2.49,0,0,1,1.33-.65H353c.47-.19.9-.33,1.15,0a1.91,1.91,0,0,1,.33.06h.5l-.08-.05c2-.78,2.29-1.29,3.84,1.05.23.35.73.6.5,1.09s-.77.25-1.17.14l-.26.18Z",
    transform: "translate(-154.83 -222.21)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.88,381.08a2.45,2.45,0,0,1,1.46.78,18.13,18.13,0,0,1,1.31,1.59,1.44,1.44,0,0,1,0,1.75,1.5,1.5,0,0,1-1.61.69,9.56,9.56,0,0,0-2.55-.4c-.58.08-1-.55-.9-1.17.05-.43.14-.87.26-1.43l.14-.51C226.36,381.26,226.82,380.93,227.88,381.08Z",
    transform: "translate(-154.83 -222.21)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.64,362.79a2.51,2.51,0,0,1-3.4,1,2.8,2.8,0,0,1-.53-.37,2.26,2.26,0,0,1-.5-2.53,5.37,5.37,0,0,1,.81-1.18,2.29,2.29,0,0,1,2.77-.37A3.3,3.3,0,0,1,197.64,362.79Z",
    transform: "translate(-154.83 -222.21)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.52,413.4a2,2,0,0,1-1.43-2.11c.2-.46.39-.79.54-1.14a2.24,2.24,0,0,1,2.33-1.22,1.18,1.18,0,0,1,1.22,1.14v0a2,2,0,0,0,.77,1.62,1,1,0,0,1,.32.46,1.34,1.34,0,0,1,0,1.26,1.47,1.47,0,0,1-1.45.68A17,17,0,0,1,384.52,413.4Z",
    transform: "translate(-154.83 -222.21)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.32,419.29c.26.69.47,1.4.68,2.12.31,1.1-.5,1.74-1.09,2.43s-.9,0-1.33-.13a.81.81,0,0,0-.38,0c-.88.09-1.22-.45-1.41-1.33a8.25,8.25,0,0,1,.29-1.56,3.31,3.31,0,0,1,1.84-2,.92.92,0,0,1,1.29.25A.65.65,0,0,1,292.32,419.29Z",
    transform: "translate(-154.83 -222.21)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.93,344.84a4.57,4.57,0,0,0-.17.91,1.23,1.23,0,0,1-1,1.44l-.16,0a2.11,2.11,0,0,1-2.54-.9,2.91,2.91,0,0,1,.46-3.57c.88-1.16,1-1.05,2.29-.28A2.24,2.24,0,0,1,322.93,344.84Z",
    transform: "translate(-154.83 -222.21)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.35,427.93l0-.37a1.4,1.4,0,0,1,1.15-1.31,3.11,3.11,0,0,1,3.08.6,2.88,2.88,0,0,1,.18,2c-.12,1.45-.56,1.81-2,1.8a2.41,2.41,0,0,1-.38,0,2.08,2.08,0,0,1-2.08-2.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.06,414.25a13,13,0,0,1,2-1.1,3.19,3.19,0,0,1,2.39-.15,1.7,1.7,0,0,1,1.22,1.7c0,1-.6,1.3-1.5,1.59-1.51.43-2.71-.3-4-.57a.79.79,0,0,1-.11-1.47Z",
    transform: "translate(-154.83 -222.21)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.42,264.4a1.63,1.63,0,0,1-.86,1.84,1.21,1.21,0,0,1-1.47-.21c-1.45-1.16-1.74-2.8-1.73-4.53,0-.4.59-.73,1-.59A4.63,4.63,0,0,1,233.42,264.4Z",
    transform: "translate(-154.83 -222.21)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.84,401.94a1.55,1.55,0,0,1,.33.39.71.71,0,0,0,.46.17c.23,0,.54-.16.65.14s-.26.33-.47.38a.61.61,0,0,0-.38.55c0,.24,0,.76-.05,1.13s-.11.74-.4.8c-.68.15-1.18.75-1.92.68a.59.59,0,0,1-.32-.17,6,6,0,0,0-1.26-1.85.5.5,0,0,1,0-.52,5.24,5.24,0,0,0,.27-.69C288.3,401.27,289.37,400.92,290.84,401.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.28,448c.42.36,1,.56,1.14,1.18a2.87,2.87,0,0,1-.28,1.82,1.61,1.61,0,0,1-1.52,1.12c-.68,0-1.25.28-1.71-.28a2.47,2.47,0,0,1,.65-4A1.37,1.37,0,0,1,232.28,448Z",
    transform: "translate(-154.83 -222.21)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.2,399.79a.32.32,0,0,1-.55-.18,2.78,2.78,0,0,0-.63-1.33c-.91-1.16-.89-1.18-.1-2.45l.29-.48a1,1,0,0,1,1-.5,2.11,2.11,0,0,1,2.26,2,1.6,1.6,0,0,1,0,.31,7,7,0,0,1-.26,1C305.55,399,304.61,399,304.2,399.79Z",
    transform: "translate(-154.83 -222.21)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.58,428.91a.89.89,0,0,1,1,.23,6,6,0,0,0,.67.56,1.49,1.49,0,0,1,.05,2.13l-.12.12a16.32,16.32,0,0,1-1.33,1.3,1.37,1.37,0,0,1-1.93-.08,1.33,1.33,0,0,1-.35-.71l-.05-.37C285.34,430.23,285.82,429.49,287.58,428.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.29,367.63c.63-.45,1.21-.19,1.76-.24a.56.56,0,0,1,.55.43,6.71,6.71,0,0,1,.42,1.24,2.3,2.3,0,0,1-1.72,2.76l-.1,0a3.88,3.88,0,0,1-1.64-.33.79.79,0,0,1-.61-.83A3.27,3.27,0,0,1,381.29,367.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.2,323.36a1.63,1.63,0,0,1,.91,1.33,9.11,9.11,0,0,1,.22,1.48,1.8,1.8,0,0,1-1.63,1.94,1.83,1.83,0,0,1-2-1.62,2.91,2.91,0,0,1,.84-2.7C350.2,323.41,350.59,323,351.2,323.36Z",
    transform: "translate(-154.83 -222.21)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.67,306.75a9.59,9.59,0,0,1,.36,2.92,1.33,1.33,0,0,1-1.21,1.45h-.15c-.82.07-1.8-.53-1.85-1.25a5.69,5.69,0,0,1,.57-3.27C332,305.63,332.73,305.63,333.67,306.75Z",
    transform: "translate(-154.83 -222.21)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.73,382.81a4.07,4.07,0,0,1-1.65,1.51,1.5,1.5,0,0,1-2.05-.5,2.39,2.39,0,0,1-.13-.28,2.69,2.69,0,0,1,0-2.19c.29-.75.92-1,1.74-1.11.33-.25.65-.62.8-.14a2.16,2.16,0,0,0,.95,1.09,1.13,1.13,0,0,1,.39,1.55Z",
    transform: "translate(-154.83 -222.21)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229,363.63c.46-.43.44-1,.66-1.52a1.81,1.81,0,0,1,.53-.75,2.36,2.36,0,0,1,3.14,1.1h0a2.12,2.12,0,0,1-.49,2.09,1.5,1.5,0,0,1-1.7.45,1.89,1.89,0,0,0-.67,0c0-.6-.3-1-1.08-.79A.36.36,0,0,1,229,363.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.44,365h.06v.25C230.34,365.25,230.38,365.05,230.44,365Z",
    transform: "translate(-154.83 -222.21)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.2,382.8a2.43,2.43,0,0,1-.06-2.92,1.53,1.53,0,0,1,2.48-.64,1.54,1.54,0,0,1,.83,1.34c.12,2.21.47,1.71-1.67,2.67A1.22,1.22,0,0,1,373.2,382.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.37,418h0c-.43,0-.82,0-1-.28l-.28-.16c-.37-.52-.91-.61-1.38-1h0v.06c-.64-.42-.89.21-1.3.24a.68.68,0,0,1-.11-1.36.66.66,0,0,1,.39.09,1,1,0,0,0,.95,0,1.33,1.33,0,0,1,.22-.34,17.46,17.46,0,0,1,.94-1.53h-.06a1.82,1.82,0,0,0,0-.57,4.21,4.21,0,0,0,.71,0c.37,0,.73-.08.92.2a1.07,1.07,0,0,1,.34.14c.56.2,1.2,0,1.43.79h0a5.46,5.46,0,0,1,.58,1.22c.1.36.11.73-.23.85a2.11,2.11,0,0,1-.21.31C286.91,417.44,286.49,418.11,285.37,418Z",
    transform: "translate(-154.83 -222.21)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.59,322.91a1.94,1.94,0,0,1-1.49-1.3,8.14,8.14,0,0,1-.43-1.61.94.94,0,0,1,.85-1,3.28,3.28,0,0,1,2.17.41,3.88,3.88,0,0,1,1.06,1c.3.41-.13.82-.19,1.24a2.07,2.07,0,0,1-.12.49A1.69,1.69,0,0,1,257.59,322.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.15,321.73a4.77,4.77,0,0,1,.46,1.15,2,2,0,0,1,0,.69c-.55,1.8-1.68,2.09-3,.76a3.31,3.31,0,0,1-.59-.94,1.67,1.67,0,0,1,.74-2.24,1.65,1.65,0,0,1,2.3.42Z",
    transform: "translate(-154.83 -222.21)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.14,327.39a1.06,1.06,0,0,1-.43.32,1.78,1.78,0,0,1-2.25-1.1,2.21,2.21,0,0,1-.08-.35,2.15,2.15,0,0,1,.57-1.89c.21-.18.48-.42.42-.71a1,1,0,0,0,.49,0,1.91,1.91,0,0,1,2.17,1.09c.45.69.05,1.31-.36,1.88C364.49,326.88,364.33,327.15,364.14,327.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.39,395a2,2,0,0,1-2.48,1,5.85,5.85,0,0,1-.93-.48,1.13,1.13,0,0,1-.56-1.48,1.08,1.08,0,0,1,.28-.38c.16-.19.33-.37.5-.55a2,2,0,0,1,2.34-.55,1.61,1.61,0,0,1,1,2.06A1.46,1.46,0,0,1,179.39,395Z",
    transform: "translate(-154.83 -222.21)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.71,372.47a2.54,2.54,0,0,1,2.08-2.08c1.68-.15,1.7.31,1.62,1.41v.75a1.32,1.32,0,0,1-.62,1.11,2.83,2.83,0,0,1-1.75.58,1.32,1.32,0,0,1-1.41-1.23A1.42,1.42,0,0,1,394.71,372.47Z",
    transform: "translate(-154.83 -222.21)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.28,360.63a10.62,10.62,0,0,1,.34-1.26.91.91,0,0,1,.26-.47,2.62,2.62,0,0,1,1.95-.47c.65.05.76.55,1,1.13a3.12,3.12,0,0,1-1.31,2.85,1,1,0,0,1-1,.22,1.56,1.56,0,0,1-1.24-1.81C373.25,360.75,373.26,360.69,373.28,360.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.89,446.63a2.8,2.8,0,0,1-2.14.47,1.11,1.11,0,0,1-.9-1c0-.63-.19-1.18.24-1.55a5.24,5.24,0,0,1,1.54-1,1.41,1.41,0,0,1,1.55.4A2,2,0,0,1,184.89,446.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.09,324.26h.69c.82.19,1,.87,1.43,1.31a2,2,0,0,1-.25,2.56,1.84,1.84,0,0,1-2.21-.46,1.15,1.15,0,0,1-.39-.83c0-.68,0-1.37.06-2C282.45,324.38,282.76,324.29,283.09,324.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.09,353.51a.47.47,0,0,1-.14.33A.44.44,0,0,1,314.09,353.51Z",
    transform: "translate(-154.83 -222.21)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313,358.28h0a.33.33,0,0,1,0,.14,2.36,2.36,0,0,1-.52.21l.06.21a4.62,4.62,0,0,1,.27,2.52,1,1,0,0,1-.68.81,1.85,1.85,0,0,1-2.34-1.2,2,2,0,0,1-.08-.33,3.12,3.12,0,0,1,.2-1c.48-.51.84-.93,1.22-1.32a.87.87,0,0,1,.91-.26V358a1.69,1.69,0,0,1,.64-.29,1.27,1.27,0,0,1,.06-.28c0-.84.09-1.53.15-2.21a1.12,1.12,0,0,1,.83-1.12.68.68,0,0,0,.33-.16.79.79,0,0,0,.05.3,5.4,5.4,0,0,0,1.8,2.32c.22.19.31.41.15.65a3.25,3.25,0,0,1-1.24,1.36A1.85,1.85,0,0,1,313,358.28Z",
    transform: "translate(-154.83 -222.21)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.05,353.15c0-.18,0-.36.26-.37,0,0,.1.06.12.11a.38.38,0,0,1-.16.48.49.49,0,0,0-.18.14A1.47,1.47,0,0,0,314.05,353.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.05,391.76a1.55,1.55,0,0,1,0-2.16c.25-.36.39-.65.74-.73a1.89,1.89,0,0,1,2.31,1.37,1.81,1.81,0,0,1,.06.57c0,.36.22.88-.17,1-.54.22-.8.85-1.42.85A1.83,1.83,0,0,1,350.05,391.76Z",
    transform: "translate(-154.83 -222.21)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.2,435.71a1.45,1.45,0,0,1,.48-1.35c.48-.35.47-.72.64-1.12a1.45,1.45,0,0,1,1-.79,1,1,0,0,1,1.22.54v0a1.73,1.73,0,0,1-.39,2c-.25.44-.42.77-.59,1.11a1.39,1.39,0,0,1-1.67.78C297.46,436.81,297.2,436.36,297.2,435.71Z",
    transform: "translate(-154.83 -222.21)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281,437.36c-.83.21-1.6-.11-2.28.41-.24.18-.61,0-.82-.27a1.26,1.26,0,0,1,.22-1.77,1.21,1.21,0,0,1,.47-.23,1.58,1.58,0,0,0,1-.5,1.64,1.64,0,0,1,1.18-.49,1.15,1.15,0,0,1,1.37.88,1,1,0,0,1,0,.43A1.89,1.89,0,0,1,281,437.36Z",
    transform: "translate(-154.83 -222.21)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283,403.15c1,.93.52,1.77.11,2.61s-1,.68-1.61.62h-.94a.63.63,0,0,1-.32-.15,1.68,1.68,0,0,1-.17-1.74C280.78,403.63,281.48,402.63,283,403.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,322a6.77,6.77,0,0,1-1.17-.81,1.84,1.84,0,0,1,.77-2.34,1.44,1.44,0,0,1,1.75-.11,1.47,1.47,0,0,1,.63,1.47,4.11,4.11,0,0,1-.25,1.09A1.39,1.39,0,0,1,300,322Z",
    transform: "translate(-154.83 -222.21)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.58,395.55a.5.5,0,0,1-.14.34,3.21,3.21,0,0,0-.81,2,.69.69,0,0,1-.77.61h0a1,1,0,0,1-.78-.92.85.85,0,0,1,.08-.35,1.47,1.47,0,0,0,.08-1.6,1.88,1.88,0,0,1,0-1.4c.48-.62,1-1,1.66-.71A1.73,1.73,0,0,1,337.58,395.55Z",
    transform: "translate(-154.83 -222.21)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.66,407.58c.13.18.06.45-.1.48-.68.14-.88.56-1.12,1.19a1.29,1.29,0,0,1-1.68.73,1.33,1.33,0,0,1-.6-.47c-.16-.19-.23-.45-.4-.64a2.51,2.51,0,0,0-1.22-.88v.25a.82.82,0,0,1-.37.45h.11c-.55.37-1,.52-1.3,0a1.94,1.94,0,0,1-.33-.23,1.22,1.22,0,0,1-.32-1.12.17.17,0,0,0-.13.07,1.7,1.7,0,0,1-.59-.1l-.17.15c-.28.45-.57.67-1,.5a1,1,0,0,1-.09-1.87c.58-.24.93.06,1.27.64l.06-.07a1.76,1.76,0,0,0,.8-.32l-.05-.25a2,2,0,0,1,.09-.9l-.2-.15c-.49-.34-.76-.66-.75-1.15a.58.58,0,0,1,.6-.56.41.41,0,0,1,.19,0,1,1,0,0,1,.62.65,3.18,3.18,0,0,1,0,1.15h.18a3.1,3.1,0,0,1,.23,1,.66.66,0,0,1,.19.09c.53.29,1.17.32,1,1.14v.07a.38.38,0,0,1,.15,0,1.15,1.15,0,0,0,1.48,0c.85-.66,1-.67,1.74,0,.48.45.79.49,1.23,0a.32.32,0,0,1,.45.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.6,393.58A.65.65,0,0,1,320,393a2.8,2.8,0,0,0-.69-1.7.58.58,0,0,1-.06-.81.61.61,0,0,1,.4-.19,21,21,0,0,1,2.24-.24,1.33,1.33,0,0,0,1.13-.5c.11-.16.4-.18.7-.14v-.25a1.51,1.51,0,0,1,1.56-.6.8.8,0,0,1,.48.23,1.55,1.55,0,0,1,.34,1.72,1.34,1.34,0,0,1-1.27.91c-.65.05-1-.4-1.18-1.09h0a.51.51,0,0,1-.18.09c-.25-.07-.45-.12-.47-.07a7.58,7.58,0,0,1-.36.84c-.43.66-1.16,1.12-1.22,2C321.38,393.51,320.94,393.63,320.6,393.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.5,358.63a1,1,0,0,1,1.24-.69,1,1,0,0,1,.38.21l.15.12a2.51,2.51,0,0,1,1.26,2.53c0,.47-.34.62-.8.81a1.19,1.19,0,0,1-1,.1A2.77,2.77,0,0,1,299.5,358.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.62,450.63a1.82,1.82,0,0,1,1.43-.28,3.41,3.41,0,0,1,.55.14,1.38,1.38,0,0,1,.52,2.26,3.22,3.22,0,0,1-1.64.86c-.86.12-1,0-1.18-1.29A1.49,1.49,0,0,1,242.62,450.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.49,291.57a.8.8,0,0,1,1-.56h0a3,3,0,0,1,1.71,1.61,2.25,2.25,0,0,1-.43,2.63,2.21,2.21,0,0,1-.85-.11A3.74,3.74,0,0,1,258.49,291.57Z",
    transform: "translate(-154.83 -222.21)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.78,386.47c.25.41.77.64.81,1.27-.42.22-.6.71-.93,1.08a1,1,0,0,1-1.17.35c-.23-.07-.49-.08-.85-.19a1.91,1.91,0,0,1-.19-2.33,1.3,1.3,0,0,1,1.69-.73A1.27,1.27,0,0,1,319.78,386.47Z",
    transform: "translate(-154.83 -222.21)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306,430.07c0-.93,1.13-1.71,1.83-1.3a1.86,1.86,0,0,1,1.14,2.22,3.14,3.14,0,0,1-.33.81,1.05,1.05,0,0,1-1.41.46,1.37,1.37,0,0,1-.2-.13A2.22,2.22,0,0,1,306,430.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.32,384.76a1.21,1.21,0,0,1-.92-.84c-.08-.44.17-.67.54-.86a8.86,8.86,0,0,1,3.79-.79c.09,0,.18-.09.29-.14a2.46,2.46,0,0,0,.57-.38h-.11c-.29-.45-.8-.57-.68-1.06l-.21-.16c-.52-.74-.29-1.48-.5-2.3h0l-.06.12c-.17-.2-.31-.37-.3-.51.07-.5-.12-.68-.6-.61a.44.44,0,0,1-.33-.11l-.15.06h-.78l.09.08a3.17,3.17,0,0,1-.87.15l-.35.22a5.06,5.06,0,0,1-1.8,3.34c-.85.92-1.69.78-2.51-.23a3,3,0,0,1-.35-.6V380l-.09.23a2.54,2.54,0,0,1-.39-1.63l-.14.07a6.8,6.8,0,0,1-1.42-.11v.14a.45.45,0,0,1-.39-.06h-.07v.12a1.29,1.29,0,0,1-1.23-1.34v-.08l-.17-.18a.39.39,0,0,1,0-.26H317a6.42,6.42,0,0,1-.69-.58v.08c-.37-.31-.76-.52-.77-.93l-.18-.28c-.19-.29-.31-.49-.48-.79l-.06.05a11.76,11.76,0,0,0-.59-1.73l-.39-.52a2,2,0,0,1-.54-.45v.11a1.38,1.38,0,0,1-.57-1.21,1.06,1.06,0,0,1,.52-1.1c.53-.23,1-.2,1.2.37a1.38,1.38,0,0,1,.29.08,5,5,0,0,1,.64.26h0v-.05c.47,0,.61-.25.84-.3a1.13,1.13,0,0,0,0-.26,2.73,2.73,0,0,1,.83-1.45v-.26a1.68,1.68,0,0,0,.58-2,6,6,0,0,1-.28-1.09,1.15,1.15,0,0,1,.32-1,4.15,4.15,0,0,0,1.38-3.3,4.07,4.07,0,0,1,.23-1.1,1.23,1.23,0,0,1,.82-.93c1.28-.63,1.66-.57,2.61.48.13.14.24.28.36.43a2.65,2.65,0,0,1-.54,3.72,2.69,2.69,0,0,1-.46.28c-.34.15-.85.18-1,.54-.25.84-.8.8-1.48.75s-.73.12-.74.78a1.45,1.45,0,0,0,.53,1.33,1.29,1.29,0,0,1,.57.89h.12v.14l.1-.09c.4.41.68.78,1.09,1.26h0v-.08c.57.11,1,.15,1.44.25s.61,0,.69-.38a1.16,1.16,0,0,1,.73-1,1.75,1.75,0,0,1,1.27-.16,1.55,1.55,0,0,1,.63.37c.22.24.18.54,0,.89h.09a.38.38,0,0,0,.24.05h0c1,0,1,0,1.09.8l.25.24c.37.29.68.52,1.07.79v-.11c.37-.21.58-.07.6.21a2.57,2.57,0,0,1-.06.78,1.55,1.55,0,0,1,0,.43,1.93,1.93,0,0,0,.27.56v-.1c.58.06.79-.25,1.06-.51.78-.76.81-.74,1.87-.09a.8.8,0,0,0,1.13-.05.6.6,0,0,0,.14-.21c.12-.17.13-.43.3-.69l-.16-.1a6.12,6.12,0,0,0-.43-.69v.06c-.64-.45-.68-.49-.26-.93V369c0-.54.13-.87.56-1a10.48,10.48,0,0,1,1.37-.26l-.08-.08c.55-.3.63-.28.62.24a1.21,1.21,0,0,1,.24.21c.76,1.78.43,2.57-1.26,3v.2a3.75,3.75,0,0,1-1.48,2,.71.71,0,0,1-.69,0c-1-.48-1.52-.22-2.06,1h.2a2.76,2.76,0,0,1,1.82,1.85c0,.15.22.27.42.53l.05-.1c.57.21.52.81.87,1.18a.86.86,0,0,0,.21-.07c.07,0,.23-.15.33-.19h0l-.08-.06c.25-.31.5-.43.75-.31a1,1,0,0,1,.33-.07c.59-.21,1-.51,1.45.07a1,1,0,0,0,.78.37,1.5,1.5,0,0,0,.2.64l0,.1v-.16a1.85,1.85,0,0,1,.58,1.87,2.44,2.44,0,0,1,0,.54,1.09,1.09,0,0,0,.1.5h0c1.05.56,1.86.64,2.42-.51.3-.64.92-.51,1.6-.3h0v-.08c.5-.29.87-.54,1.25,0a4.8,4.8,0,0,1,.62.79.37.37,0,0,1,.26.07,3,3,0,0,1,.74.64l.11-.12a8.22,8.22,0,0,1,1.43.13c.43.07.56.4.48.86s-.36.45-.67.41c-.28-.86-.89-.59-1.41-.72a1.37,1.37,0,0,1-.15.21c-.6.77-1.51.48-2.12,1s-.73.48-1.25,0a2,2,0,0,0-2.34-.67,1,1,0,0,1-.74,0,12.15,12.15,0,0,0-2.82-.33,1.92,1.92,0,0,0-.66.12c-.77.13-1.41.18-2.16.32h.05c-.28.23-.57.31-.69.5a1.24,1.24,0,0,1-1.69.46l-.07,0c-.17-.08-.35-.13-.53-.2a2.78,2.78,0,0,0-3.67.81A.53.53,0,0,1,326.32,384.76Zm-2.66-13.13v.09h0v-.09Zm5.87,3.56v-.14h0l-.1.14Zm-11.16.26v0Z",
    transform: "translate(-154.83 -222.21)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.89,348.43l.29-1.58a1.1,1.1,0,0,1,.95-1,1.28,1.28,0,0,1,1.3.54,3.28,3.28,0,0,1,.45.82,1.34,1.34,0,0,1-.73,1.76,1.38,1.38,0,0,1-.83.07C311.84,348.89,311.2,349.09,310.89,348.43Z",
    transform: "translate(-154.83 -222.21)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.81,311.36A2,2,0,0,1,346,311a6.38,6.38,0,0,1-.79-1.2c-.28-.64,0-1.14.73-1.74a1.24,1.24,0,0,1,1.57.06,1.69,1.69,0,0,1,.75,1.44A2.06,2.06,0,0,1,346.81,311.36Z",
    transform: "translate(-154.83 -222.21)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.2,370.06a1.14,1.14,0,0,1,1.38-.07,1.31,1.31,0,0,1,.75,1.55c-.28.75.06,1.4-.05,2.15-.57-.37-.85-1-1.58-1.18-.34-.09-.61-.58-.83-.95A1.19,1.19,0,0,1,236.2,370.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.82,399.24a1.45,1.45,0,0,1-2.85-.15,1.7,1.7,0,0,1,.87-1.73c.67-.46,1.17-.24,1.78.31A2,2,0,0,1,274.82,399.24Z",
    transform: "translate(-154.83 -222.21)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.74,419c-.67.17-1.07-.25-1.37-.73a1.46,1.46,0,0,1-.17-1.62,1.58,1.58,0,0,1,1.93-.66c.57.22.8.77.63,1.56a5.34,5.34,0,0,1-.41,1.16A4.27,4.27,0,0,1,329.74,419Z",
    transform: "translate(-154.83 -222.21)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.36,365.42Z",
    transform: "translate(-154.83 -222.21)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.36,365.48a4.23,4.23,0,0,1,1,1.53.58.58,0,0,1-.16.79h0a8.45,8.45,0,0,1-1,.6,1.33,1.33,0,0,1-1.76-1.25,2.5,2.5,0,0,1,.68-1.51c.36-.36.8-.23,1.2-.23Z",
    transform: "translate(-154.83 -222.21)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.81,391.94c-.27-.17-.55-.38-.57-.7,0-.74-.51-.9-1.11-1a.77.77,0,0,1-.33-1.21.64.64,0,0,1,.86,0,.47.47,0,0,1,.23.27c.22.63.58.72,1.15.42.19-.11.48,0,.83,0v-.09c.93-.52,1.16-1.42,1.67-2.11a.56.56,0,0,1,.78-.16l0,0a.54.54,0,0,1,.15.75l-.06.07a3,3,0,0,0-1,1.48c-.09.33-.51.4-1,.4l.08.13a2.22,2.22,0,0,1,.14.89,1.14,1.14,0,0,1-1.2,1.08A1.22,1.22,0,0,1,337.81,391.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.77,339.34a1.18,1.18,0,0,1,.11-1.65,1.22,1.22,0,0,1,.32-.2c.28-.14.58-.24.86-.36.48-.2.67.14.92.59a4.39,4.39,0,0,1,.4,1.75,1.15,1.15,0,0,1-.81.95.76.76,0,0,1-.84-.19C277.4,340,277.07,339.65,276.77,339.34Z",
    transform: "translate(-154.83 -222.21)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.61,453.07c.61-.44,1.17-.28,1.75.34a1.17,1.17,0,0,1,.3,1.47,1.81,1.81,0,0,1-1.39.85,1.29,1.29,0,0,1-1.25-.64A1.91,1.91,0,0,1,265.61,453.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.2,445.27a1.74,1.74,0,0,1,1.93,0,1.42,1.42,0,0,1,.21,1.57,2.9,2.9,0,0,1-.63.81,1.91,1.91,0,0,1-1.41,0,1.09,1.09,0,0,1-.6-1.07A1.34,1.34,0,0,1,226.2,445.27Z",
    transform: "translate(-154.83 -222.21)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.55,398.63c.11-.15.3-.24.39-.39a1.13,1.13,0,0,0,.1-.51,1.08,1.08,0,0,0-.1-.35h.13c.22.88,1.61.72,1.61,1.92a1.39,1.39,0,0,1-.13,1,1.3,1.3,0,0,1-1.78.49h0a1.23,1.23,0,0,1-.58-1.58A2.2,2.2,0,0,1,293.55,398.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.57,396.11a1.33,1.33,0,0,1,1-1.22c.57-.21.95.07,1.33.63s.62.84.44,1.31a1.93,1.93,0,0,1-1.26,1,1.13,1.13,0,0,1-1.41-.75s0,0,0-.06A3.12,3.12,0,0,1,298.57,396.11Z",
    transform: "translate(-154.83 -222.21)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.47,290.85a2,2,0,0,1,2-2h.22c.44.07.55.45.59,1a2.24,2.24,0,0,1-1.49,1.91,1,1,0,0,1-1.26-.64A1.28,1.28,0,0,1,420.47,290.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.08,355.91a1.27,1.27,0,0,1,1.49-.81,1.15,1.15,0,0,1,.93,1.33.13.13,0,0,1,0,.06,3.08,3.08,0,0,1-.35,1.06,1,1,0,0,1-1.35.42l-.18-.12A1.57,1.57,0,0,1,323.08,355.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.88,342.63a11,11,0,0,1,.66,1.33,1.29,1.29,0,0,1-.26,1.55c-.51.49-1,.19-1.6-.25-.74-1.07-.21-1.86.31-2.64a.48.48,0,0,1,.63-.26A.49.49,0,0,1,291.88,342.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.14,329.39a1.59,1.59,0,0,1,.06-1.76,1.33,1.33,0,0,1,1.44-.62,1.19,1.19,0,0,1,.93,1.06,1.37,1.37,0,0,1-.45,1.29,2,2,0,0,1-.45.24A1.28,1.28,0,0,1,372.14,329.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.59,413.69a1.2,1.2,0,0,1-.73,1.53l-.1,0c-.52.2-1-.11-1.48-.83l-.51-.85a8.69,8.69,0,0,1,.75-.61C251.47,412.31,251.83,412.43,252.59,413.69Z",
    transform: "translate(-154.83 -222.21)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.8,424.28a1.69,1.69,0,0,1-1.61.21c-.54-.24-.58-.77-.55-1.28a1.89,1.89,0,0,1,.24-.65c.54-.65,1.14-.82,1.72-.4a1.34,1.34,0,0,1,.55,1.49A1.08,1.08,0,0,1,296.8,424.28Z",
    transform: "translate(-154.83 -222.21)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.09,429.13a1.23,1.23,0,0,1,.56-1.58,1.14,1.14,0,0,1,1.57.38l0,.06a1.64,1.64,0,0,1-.33,2.12C351.84,430.46,351.45,429.8,351.09,429.13Z",
    transform: "translate(-154.83 -222.21)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.62,422.88a1,1,0,0,1-1,.91,1.94,1.94,0,0,1-1.78-.85.54.54,0,0,1,0-.7,2.89,2.89,0,0,1,.67-.54,1.34,1.34,0,0,1,1.52-.07A1,1,0,0,1,207.62,422.88Z",
    transform: "translate(-154.83 -222.21)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.56,433.34a1.26,1.26,0,0,1,1.23.72,1.74,1.74,0,0,1-.31,1.93.88.88,0,0,1-.49.22c-.8.08-1.21-.33-1.21-1.16v-.89C249.9,433.63,250.11,433.31,250.56,433.34Z",
    transform: "translate(-154.83 -222.21)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.31,388.5a1.15,1.15,0,0,1-1.43.36,1.71,1.71,0,0,1-.91-1.11,1.19,1.19,0,0,1,.51-1.29,1,1,0,0,1,1.22,0,1.48,1.48,0,0,1,.64,2Z",
    transform: "translate(-154.83 -222.21)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.38,401.3a.94.94,0,0,1-.24,1.17,1.77,1.77,0,0,1-2.21-.16c-.39-.42-.4-.89.18-1.37a1.48,1.48,0,0,1,1.48-.38A1.43,1.43,0,0,1,203.38,401.3Z",
    transform: "translate(-154.83 -222.21)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270,431.63c.35.39.38,1,1.12,1.13.33,0,.38.45.18.75s-.52.24-1,0h-1.25a.7.7,0,0,1-.7-.7v0a2.77,2.77,0,0,1,.11-.91.84.84,0,0,1,1.07-.54A.8.8,0,0,1,270,431.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.9,447.05a1,1,0,0,1,1.19.29,2.25,2.25,0,0,1,.74,1.57.88.88,0,0,1-.61.53c-1.08.27-1.7-.1-1.89-1.13A1.15,1.15,0,0,1,327.9,447.05Z",
    transform: "translate(-154.83 -222.21)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333,414a1.33,1.33,0,0,1-.77-1.48c.06-.58.53-.8,1-1a.85.85,0,0,1,1.16.28.89.89,0,0,1,.11.35,2.91,2.91,0,0,1,0,1.1,1.42,1.42,0,0,1-.68.84C333.61,414.22,333.38,414.14,333,414Z",
    transform: "translate(-154.83 -222.21)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.58,370.74a.67.67,0,0,1,.52,0c.5.22.51.89.89,1.14s1,.29,1.21.78a1.63,1.63,0,0,1,.1.66c-.2.72-.59.9-1.17.71s-.79-.39-.74-1.07a.93.93,0,0,0-.55-1,1.32,1.32,0,0,1-.49-.53A.5.5,0,0,1,303.58,370.74Z",
    transform: "translate(-154.83 -222.21)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.58,332.91a1.23,1.23,0,0,1,.26,1.47,1.13,1.13,0,0,1-1.53.47l-.05,0a1.6,1.6,0,0,1-.32-1.86C293.26,332.41,293.53,332.38,294.58,332.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.86,434.93a1,1,0,0,1,1.06-.58c.64,0,1,.26,1.06.84a3.09,3.09,0,0,1-.13,1c-.9.68-1.27.69-1.85.22C319.58,436.11,319.54,435.58,319.86,434.93Z",
    transform: "translate(-154.83 -222.21)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.58,291.82c-.16-.46-.47-.92-.1-1.41a1.19,1.19,0,0,1,1.51-.56,1.63,1.63,0,0,1,.33,2,1.07,1.07,0,0,1-1.09.57A.75.75,0,0,1,360.58,291.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.33,426a1.1,1.1,0,0,1,1.56,0,1.12,1.12,0,0,1,.28,1.06c-.15.54-.35,1.19-1,1.24s-.85-.64-1.09-1.13S303.07,426.42,303.33,426Z",
    transform: "translate(-154.83 -222.21)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.7,400.26a1.87,1.87,0,0,1,1.48-.34,1.91,1.91,0,0,1,.48.46c.54.81.26,1.48-.65,1.53a1.63,1.63,0,0,1-1.48-.54.72.72,0,0,1,.05-1A.34.34,0,0,1,218.7,400.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.7,248.56a8.57,8.57,0,0,1-.05,1.24.66.66,0,0,1-.62.6.89.89,0,0,1-.8-.41,2.2,2.2,0,0,1-.26-1.8.83.83,0,0,1,1-.66.74.74,0,0,1,.26.1A1.41,1.41,0,0,1,288.7,248.56Z",
    transform: "translate(-154.83 -222.21)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.88,440.94c.12-.89,0-1.87,1-2.51a1.45,1.45,0,0,1,1.36,1,1.11,1.11,0,0,1-.49,1.49l-.11.05a7.45,7.45,0,0,1-1.25.35.42.42,0,0,1-.5-.3S273.88,441,273.88,440.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.41,395.33a1,1,0,0,1,.34,1.37,1.09,1.09,0,0,1-.13.17,1.17,1.17,0,0,1-1.38.26,3.46,3.46,0,0,1-.93-.58.65.65,0,0,1-.12-.89l.12-.11A2.19,2.19,0,0,1,169.41,395.33Z",
    transform: "translate(-154.83 -222.21)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.28,378.46a1.2,1.2,0,0,1,.41,1.48c-.2.7-.73.74-1.43.64a1,1,0,0,1-.67-.71c-.12-.64,0-1,.5-1.24S222.83,378.16,223.28,378.46Z",
    transform: "translate(-154.83 -222.21)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.2,361.91a3.1,3.1,0,0,1,0,.86v.68c0,.84-.16,1.15-.9,1.27a.53.53,0,0,1-.65-.37.24.24,0,0,1,0-.08,3.14,3.14,0,0,1,.77-2.54A.52.52,0,0,1,309.2,361.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.61,375.19c.75,0,.9.53,1,1.24s-.38,1.06-1,1.06-1.19-.86-1.16-1.66C272.46,375.41,272.89,375.18,273.61,375.19Z",
    transform: "translate(-154.83 -222.21)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296,435.13a1.79,1.79,0,0,1-.41,1.4.58.58,0,0,1-.8.18h0c-1-.54-1-1.36-.56-2.36.43-.31.78-.47,1.15-.3A1.24,1.24,0,0,1,296,435.13Z",
    transform: "translate(-154.83 -222.21)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265,373.8a1.07,1.07,0,0,1-1.34.27,1.15,1.15,0,0,1-.46-1.44c.16-.4.36-.84.87-.87a1,1,0,0,1,1,.65,2.47,2.47,0,0,1,.21.65A1.86,1.86,0,0,1,265,373.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.83,380.06c.49.06,1,.33,1.48.36l.21-.27a1.63,1.63,0,0,1,2.22,0,1.9,1.9,0,0,1-.21,2.25,1.58,1.58,0,0,1-1,.39c-.5,0-.8-.28-1.15-.8h0v.11a1.72,1.72,0,0,0-1,.13c-1.08.22-1.53-.16-1.52-1.23C259.76,380.26,260.11,380,260.83,380.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.36,371.55a.64.64,0,0,1,.61-.35,1.5,1.5,0,0,1,1.26,1.21,1.11,1.11,0,0,1-1,1.09c-.43.09-.91,0-1,.48a1.24,1.24,0,0,0-.1-.66A1.72,1.72,0,0,1,338.36,371.55Z",
    transform: "translate(-154.83 -222.21)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.52,419.26a2.76,2.76,0,0,1,.87-.56c.46.25.79.53,1.15.76a.48.48,0,0,1,.24.62c-.08.24-.2.46-.29.69-.27.73-.28.74-.94.06-.2-.2-.42-.19-.64-.28C337.2,420.29,337.08,419.78,337.52,419.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.11,443.57a1,1,0,0,1-.19,1.15,1.84,1.84,0,0,1-1.56.41.84.84,0,0,1-.74-.71,1.62,1.62,0,0,1,1.8-1.4h.05A1,1,0,0,1,218.11,443.57Z",
    transform: "translate(-154.83 -222.21)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.76,405.51c.33.64,1,1.15.78,2.07-1-.06-1.65-.71-2.53-.91-.07,0-.13-.2-.13-.32a1,1,0,0,1,.7-1C162.05,405.16,162.58,405.17,162.76,405.51Z",
    transform: "translate(-154.83 -222.21)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.91,353.86c.51-.49,1.21,0,1.74-.33a.93.93,0,0,1,.35-.13c.63-.15,1.06.26,1,.93a1,1,0,0,1-.77.88c-.32,0-.58,0-.65-.13C362.15,354.47,361,354.84,360.91,353.86Z",
    transform: "translate(-154.83 -222.21)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.94,396.39c-.2-.06-.35-.33-.53-.64a1.49,1.49,0,0,1,.26-.62.73.73,0,0,1,.83-.28.77.77,0,0,1,.55.69,2.36,2.36,0,0,1,0,.75.59.59,0,0,0,.41.73h0a1,1,0,0,1,.58.45.6.6,0,0,1-.31.77.49.49,0,0,1-.64-.21.55.55,0,0,1-.13-.34C331.07,396.89,330.62,396.63,329.94,396.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.8,328.58a2.6,2.6,0,0,1,.57-.48.94.94,0,0,1,1.3.32.91.91,0,0,1,.12.68c-.18.8-.56,1.21-1.19,1.29s-.73-.2-1-1.2A1.63,1.63,0,0,1,355.8,328.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.39,290.51a1.82,1.82,0,0,1,.77,1.22.87.87,0,0,1-.7,1,.9.9,0,0,1-.43,0,1.37,1.37,0,0,1-.88-.64c-.24-.42,0-.83.19-1.35S295,290.26,295.39,290.51Z",
    transform: "translate(-154.83 -222.21)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.77,315.55a1.66,1.66,0,0,1-.1,1.44.81.81,0,0,1-1,.33,1.28,1.28,0,0,1-.85-1.29c0-.6.46-.84.92-1.08C302.2,315.08,302.62,315.16,302.77,315.55Z",
    transform: "translate(-154.83 -222.21)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.13,345.12a.79.79,0,0,1-.45-.22.46.46,0,0,1,.14-.64h0c.29-.24.77.07,1.07-.46a1.39,1.39,0,0,1,1.37-.68.53.53,0,0,1,.4.31c.11.5-.62,1.52-1.14,1.46A2.23,2.23,0,0,0,327.13,345.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.07,349.69a.92.92,0,0,0-.36-1.07c-.08-.23-.14-.4-.09-.46.49-.51,1.19-.82,1.42-1.58.08-.25.61-.15.8.11s.31.67,0,.85a1.7,1.7,0,0,0-.79,2.27l0,.08c.11.24-.21.42-.47.45C334.2,350.41,334,350.17,334.07,349.69Z",
    transform: "translate(-154.83 -222.21)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.33,388.39a10.68,10.68,0,0,1-2,1v.24a2.43,2.43,0,0,1-.2.25c-.35.35-.72.7-1.27.41a1.31,1.31,0,0,1-.45-1.47,1,1,0,0,1,.53-.7,1,1,0,0,1,1.21.25l.14-.15c.73-.29.81-.93,1.18-1.34a.66.66,0,0,1,1.19.21A1,1,0,0,1,333.33,388.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239,321.88a.75.75,0,0,1,.76-.65,1.41,1.41,0,0,1,1.13.52,1.14,1.14,0,0,1-.07,1.31c-.56.32-1,.39-1.45,0A1.22,1.22,0,0,1,239,321.88Z",
    transform: "translate(-154.83 -222.21)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.11,351.09c-1.29-.84-1.3-1.31-.18-2a2.59,2.59,0,0,1,.33-.17.89.89,0,0,1,1.16.46,1.31,1.31,0,0,1,.06.27,3.05,3.05,0,0,1,0,.74c0,.31,0,.63-.36.8S390.54,351.14,390.11,351.09Z",
    transform: "translate(-154.83 -222.21)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.28,349a1.59,1.59,0,0,1,1.21.1,1.26,1.26,0,0,1,.49.91,1.05,1.05,0,0,1-.93,1.15,1.07,1.07,0,0,1-.4,0,1.45,1.45,0,0,1-.88-.63,1,1,0,0,1,.28-1.39A1,1,0,0,1,205.28,349Z",
    transform: "translate(-154.83 -222.21)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.11,370.54c.06-.4.36-.64.92-.62a1.48,1.48,0,0,1,.29.12.93.93,0,0,1,.43,1.12c-.2.56-.16,1.26-.74,1.63a.35.35,0,0,1-.47-.09l0,0A4.24,4.24,0,0,1,273.11,370.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.47,394.24c-.07,0-.19-.25-.19-.25.67-.51.66-1.5,1.41-1.93a.59.59,0,0,1,.82.16v0a2.46,2.46,0,0,1,.24.84c-.38,1.27-.38,1.27-1.35,1.22C343.1,394.28,342.78,394.28,342.47,394.24Z",
    transform: "translate(-154.83 -222.21)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.58,365.9a1.15,1.15,0,0,1,.72,1.36,1.33,1.33,0,0,1-1.15,1,2.23,2.23,0,0,1-1.14-.53h0v.16a3.53,3.53,0,0,1-.46.15v.22c.05.55.07,1,.09,1.5h0l.11-.1a1.16,1.16,0,0,0,1.38.32l-.05-.31c.3-.61.65-.71,1.05-.36a.66.66,0,0,1,0,.93l0,0a3,3,0,0,1-.51.49l.13.16c.3.8.64,1.49-.2,2a1.07,1.07,0,0,1,.14.16c.38.42.72.7,1,1a.57.57,0,0,1,0,.8l0,0a.72.72,0,0,1-1,0,1.76,1.76,0,0,1-.46-.79c-.09-.53-.43-.71-.87-.85l-1.05-.35c-.57-.19-.58-.2-.26-1.18a.14.14,0,0,1-.11-.1c0-.84,0-.83-.65-.88a.56.56,0,0,1-.38-.19h-.27c-1.67-.23-2-1.46-2.32-2.69a.86.86,0,0,1,.34-.83,3,3,0,0,1,3.22-.33v-.08c.43-.25.64-.61,1.05-.54a1,1,0,0,1,.15-.24A1.26,1.26,0,0,1,260.58,365.9Zm-2.38,5.93Z",
    transform: "translate(-154.83 -222.21)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,394.52a.77.77,0,0,1,.88-.11.65.65,0,0,1,.36.78,2.22,2.22,0,0,0,.11,1.8s-.09.24-.17.27-.31-.12-.46-.37a3.35,3.35,0,0,0-.58-.61C324.32,395.63,324.26,395.09,325,394.52Z",
    transform: "translate(-154.83 -222.21)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.33,427.47a.74.74,0,0,1-.44-.31,1.48,1.48,0,0,1,.29-1.72.69.69,0,0,1,.88,0,1.1,1.1,0,0,1-.21,2.19,1.26,1.26,0,0,1-.52-.19Z",
    transform: "translate(-154.83 -222.21)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.53,299.39a2,2,0,0,1,.09,1.1.67.67,0,0,1-.75.59h0a1.25,1.25,0,0,1-1.17-1.33h0a2.4,2.4,0,0,1,.11-.48c.17-.34.38-.67.82-.65A1.08,1.08,0,0,1,238.53,299.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.4,384.17c-.09.44-.46.54-1,.62a2,2,0,0,1-.49,0c-.41-.12-.9-.2-.93-.74s.35-.78.75-1a2.83,2.83,0,0,1,.7-.21.64.64,0,0,1,.65.27A1.21,1.21,0,0,1,185.4,384.17Z",
    transform: "translate(-154.83 -222.21)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.11,403.79c-.45-.06-.74-.15-.91-.46a1.1,1.1,0,1,1,2-.54C303.2,403.38,302.76,403.63,302.11,403.79Z",
    transform: "translate(-154.83 -222.21)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.32,365.26c0-.22.33-.32.6-.27s.65.2.67.54c.05.77-.36,1.53,0,2.31a.73.73,0,0,1-.15.31c-.07.09-.08,0-.18,0h-.12l.1.05c-.34.24-.67.38-.76,0l-.27-.1a1.23,1.23,0,0,1-.23-.72h-.19c-.11-.11-.16-.17-.16-.23C272.7,366.53,273.43,366.07,273.32,365.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311,290.06c0-.85.12-1,.75-1.19a.63.63,0,0,1,.3.08c.45.25.71.55.68.94a2.91,2.91,0,0,1-.31,1,.68.68,0,0,1-.79.32C311.2,291.15,311,290.77,311,290.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.6,312.22a.84.84,0,0,1,0,1c-.3.5-1,.77-1,1.41-.32-.38-.55-.63-.49-1s.12-.74.16-1.1.18-.75.62-.8S302.41,312,302.6,312.22Z",
    transform: "translate(-154.83 -222.21)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.6,314.88v-.25h0C301.68,314.88,301.61,314.87,301.6,314.88Z",
    transform: "translate(-154.83 -222.21)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.77,410.06a1.09,1.09,0,0,1,.59-.89.78.78,0,0,1,1.09.1h0a1.08,1.08,0,0,1,.22,1.14,1,1,0,0,1-1,.69A1.11,1.11,0,0,1,341.77,410.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.15,378.72l-.11-.09A.12.12,0,0,1,308.15,378.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.59,378c.49-.28.79,0,1.14.5a2,2,0,0,1,.26.62c0,.63-.12.82-.67.8H257a1,1,0,0,1-.86-.82A.93.93,0,0,1,256.59,378Z",
    transform: "translate(-154.83 -222.21)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.56,367.25a1.59,1.59,0,0,1,.67-1.75c.35-.19.66,0,1.15.9a.73.73,0,0,1,.06.3c-.23.67-.5,1.14-1.2,1.06A.72.72,0,0,1,309.56,367.25Z",
    transform: "translate(-154.83 -222.21)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.44,454.72a.94.94,0,0,1,1.26.44l0,.09a1.43,1.43,0,0,1,0,.65c-.34.8-.67.92-1.4.55a1.09,1.09,0,0,1-.64-.84C268.6,455.27,269,454.88,269.44,454.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.36,383a.36.36,0,0,1,.29-.4,1.47,1.47,0,0,0,1.14-.46c.77-.9,1-.84,1.43.28a2.25,2.25,0,0,1,.11.68c-.19.54-.51.68-.92.6a.6.6,0,0,1-.33-.16c-.4-.54-.89-.23-1.37-.19a.33.33,0,0,1-.35-.31Z",
    transform: "translate(-154.83 -222.21)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.8,446.74a1,1,0,0,1-.77.74.78.78,0,0,1-1-.21,1,1,0,0,1-.19-1,1.25,1.25,0,0,1,1.26-.8A1.12,1.12,0,0,1,306.8,446.74Z",
    transform: "translate(-154.83 -222.21)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.93,432c.25-.27.55-.56,1-.41s.4.45.45.76a6.28,6.28,0,0,1,.12.87,7.24,7.24,0,0,1-.41,1c-.26-.1-.53-.18-.79-.31a1.13,1.13,0,0,1-.7-1.42A1.18,1.18,0,0,1,354.93,432Z",
    transform: "translate(-154.83 -222.21)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218,339a.56.56,0,0,1,.62-.3,1.32,1.32,0,0,1,1.08.62,1,1,0,0,1-.14,1.27.83.83,0,0,1-1.16,0l-.08-.09A1.4,1.4,0,0,1,218,339Z",
    transform: "translate(-154.83 -222.21)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.66,407.46a1.71,1.71,0,0,1,.66,1,.72.72,0,0,1-.13.69,1.15,1.15,0,0,1-1.22.18c-.35-.1-.39-.42-.42-.74C292.51,407.85,293.09,407.63,293.66,407.46Z",
    transform: "translate(-154.83 -222.21)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.39,302c-.47,0-.78-.5-.64-1.08a7.51,7.51,0,0,1,.42-1.15c.23-.27.36-.53.64-.5s.37.3.38.55a9.26,9.26,0,0,1,0,1.29C351.09,301.7,350.77,302,350.39,302Z",
    transform: "translate(-154.83 -222.21)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.43,350.58a1,1,0,0,1,1.12.86.66.66,0,0,1,0,.28,1.17,1.17,0,0,1-.67.95c-.93-.38-1.32-1.24-.92-1.84A.73.73,0,0,1,249.43,350.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.32,379.49a.83.83,0,0,1,.46-.93,1.81,1.81,0,0,1,1.36-.21,1.66,1.66,0,0,1-.25,1.66.75.75,0,0,1-.46.27A1,1,0,0,1,406.32,379.49Z",
    transform: "translate(-154.83 -222.21)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.48,294.14a6.92,6.92,0,0,1,.46-1.2c.14-.3.14-.82.68-.67.36.1.31.48.33.78a9.43,9.43,0,0,1,0,1.42c-.19.58-.48.88-1,.75A.94.94,0,0,1,347.48,294.14Z",
    transform: "translate(-154.83 -222.21)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.8,358.23a.81.81,0,0,1-1.12.22l0,0a.7.7,0,0,1-.39-.9l0,0a1.65,1.65,0,0,1,.83-1.08c.22-.08.41-.19.45-.15a1.3,1.3,0,0,1,.37,1.81A.61.61,0,0,1,372.8,358.23Z",
    transform: "translate(-154.83 -222.21)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.59,432.55c.35.24.35.59.4,1s-.66.69-.17,1c-.47-.22-.91-.07-1.3-.36a.91.91,0,0,1-.22-1.27l0,0a.87.87,0,0,1,1.18-.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.2,347a.93.93,0,0,1-.86,1,1,1,0,0,1-.25,0c-.52,0-.62-.55-.75-.95l-.05-.18a.78.78,0,0,1,1.07-1A1.2,1.2,0,0,1,223.2,347Z",
    transform: "translate(-154.83 -222.21)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.2,347.75c0,.13-.41.12-.45-.05-.17-.64-.71-1-1.14-1.58a1.42,1.42,0,0,1,.81-1.27.58.58,0,0,1,.81.19A4.48,4.48,0,0,1,341.2,347.75Z",
    transform: "translate(-154.83 -222.21)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.57,313.33a1,1,0,0,1-.27,1.39l-.17.09a.6.6,0,0,1-.68-.14,1.13,1.13,0,0,1-.17-1.51,1.61,1.61,0,0,1,.21-.3.4.4,0,0,1,.55-.09l.08.09A5,5,0,0,1,257.57,313.33Z",
    transform: "translate(-154.83 -222.21)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.7,362.45a1.05,1.05,0,0,1,.81-.92,2.43,2.43,0,0,1,.93,0c.3.08.26.37.1.73-.09.56-.15,1-.74,1.06A1.16,1.16,0,0,1,253.7,362.45Z",
    transform: "translate(-154.83 -222.21)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.36,403.08c-.49.2-.84-.08-1.06-.68a4.21,4.21,0,0,1,.09-.87.72.72,0,0,1,.82-.6.91.91,0,0,1,.88.6A1.28,1.28,0,0,1,318.36,403.08Z",
    transform: "translate(-154.83 -222.21)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.48,328.81a.67.67,0,0,1,.85-.42.61.61,0,0,1,.22.13,1.13,1.13,0,0,1,.27,1.57l-.08.1a1.08,1.08,0,0,1-.62.37c-.25,0-.45-.18-.64-.53A1.61,1.61,0,0,1,294.48,328.81Z",
    transform: "translate(-154.83 -222.21)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.77,380.45a.77.77,0,0,1-.82.62c-1,.05-1.28-.61-.67-1.65a2.42,2.42,0,0,1,1,.12A.77.77,0,0,1,181.77,380.45Z",
    transform: "translate(-154.83 -222.21)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421.68,367.5a1.13,1.13,0,0,1,.65-1.39,1,1,0,0,1,.91.05c.24.13.32.37.29.76a1.29,1.29,0,0,1-.71,1A.94.94,0,0,1,421.68,367.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.78,421.75a1,1,0,0,1,1.1-.71A1.34,1.34,0,0,1,372,422a.61.61,0,0,1-.26.81,1.18,1.18,0,0,1-1.06.22A1.28,1.28,0,0,1,369.78,421.75Z",
    transform: "translate(-154.83 -222.21)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.37,311.63a3,3,0,0,1,.07-1.43c.77-.68,1.08-.66,1.35-.08a1.48,1.48,0,0,1-.19,1.75.67.67,0,0,1-.68.22A.74.74,0,0,1,326.37,311.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.58,376a1.2,1.2,0,0,1-.17-1.07c.07-.34.3-.52.76-.56a1.08,1.08,0,0,1,.83,1,.83.83,0,0,1-.59.85A.69.69,0,0,1,302.58,376Z",
    transform: "translate(-154.83 -222.21)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.41,380.26a.92.92,0,0,1-1.24,1.31c-.31-.42-.55-.72-.47-1.12a.82.82,0,0,1,.41-.59A1.2,1.2,0,0,1,319.41,380.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.29,400c.35-.92.53-1.07,1-.93a.89.89,0,0,1,.72,1,2.28,2.28,0,0,1,0,.37.65.65,0,0,1-.63.68.68.68,0,0,1-.37-.09A1.08,1.08,0,0,1,338.29,400Z",
    transform: "translate(-154.83 -222.21)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.2,405.54a.5.5,0,0,1,0,.34c-.13.32-.61.46-.61.86a5.39,5.39,0,0,0-.75.31.77.77,0,0,1-1-.41l0-.06a.64.64,0,0,1,.48-.77.61.61,0,0,1,.27,0,2,2,0,0,0,1.36-.39.18.18,0,0,1,.3.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.39,244a1,1,0,0,1-.52.93.54.54,0,0,1-.69-.09c-.52-.63-.36-1.39.52-2A1.37,1.37,0,0,1,350.39,244Z",
    transform: "translate(-154.83 -222.21)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.74,468.48a1.26,1.26,0,0,1-1,.31c-.75-.52-.84-.78-.51-1.15a2.36,2.36,0,0,1,.42-.36.7.7,0,0,1,1,0A.86.86,0,0,1,217.74,468.48Z",
    transform: "translate(-154.83 -222.21)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.5,420.42a.75.75,0,0,1-.14.85c-.24.28-.52.27-.92.06a5,5,0,0,1-.6-1.26.64.64,0,0,1,.41-.74.53.53,0,0,1,.66.17A4.65,4.65,0,0,1,354.5,420.42Z",
    transform: "translate(-154.83 -222.21)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.52,357.73a2.37,2.37,0,0,1,.08,2c0,.09-.21.12-.44.15-.82-.46-.72-1.21-.82-1.87a.54.54,0,0,1,.39-.57A.59.59,0,0,1,259.52,357.73Z",
    transform: "translate(-154.83 -222.21)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.64,316.45a1.52,1.52,0,0,1,.34-.33c.52-.22,1-.34,1.24.14a1.07,1.07,0,0,1-.32,1.16,1,1,0,0,1-1.2,0C415.34,317.15,415.46,316.79,415.64,316.45Z",
    transform: "translate(-154.83 -222.21)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264,304l.17.34c.23.56,0,.8-1,1a.9.9,0,0,1-.69-.73c-.17-.74-.08-1.1.34-1.33S263.67,303.31,264,304Z",
    transform: "translate(-154.83 -222.21)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.41,370.82a1.21,1.21,0,0,1,.46-1.32c.43-.35.8-.14,1.17.32a1.29,1.29,0,0,1-.07,1,.86.86,0,0,1-1,.35C223.75,371.15,223.49,371.11,223.41,370.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.2,408.63l.16.1a1,1,0,0,1-.65,1.09.85.85,0,0,1-.7,0c-.45-.23-.47-.82,0-1.55h.26l-.07-.16a2.79,2.79,0,0,1,.09-1l-.19-.14c-.17-.34-.3-.6-.46-1h-.07a10.8,10.8,0,0,1-.55-1.07,1.68,1.68,0,0,1,.14-1.4c.18-.43.4-.81.87-.8l.22-.2a2.94,2.94,0,0,1,.65-.16h-.12c.94-.32,1.76-.35,2.2.48l.32.18a1.77,1.77,0,0,1,.31,1.54h.07a8,8,0,0,1,0,1.2c0,.27-.09.53-.35.58l-.11.2a.83.83,0,0,1-.23.27h.11c-.16.54-.1,1.14-.83,1.08S340.52,407.81,340.2,408.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.61,419.41a1.15,1.15,0,0,1-.14,1.46c-.89.23-1.06.16-1.19-.37-.18-.74,0-1.19.53-1.38A.65.65,0,0,1,344.61,419.41Z",
    transform: "translate(-154.83 -222.21)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.79,330.58h0c.39-.32.59-.23.58.11a.8.8,0,0,1,.21.2c.64.43.53.95.45,1.44a.73.73,0,0,1-.91.68,1.62,1.62,0,0,1-.75-.38v.1c-.43-.37-.43-.73-.15-1v-.32A1,1,0,0,1,313.79,330.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.63,377.1a1.11,1.11,0,0,1-.8,1.25l-.09-.05a2.79,2.79,0,0,1-.55-.2,2.53,2.53,0,0,1-.38-1,1.07,1.07,0,0,1,1-1.08C308.27,376,308.61,376.47,308.63,377.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.81,378.35Z",
    transform: "translate(-154.83 -222.21)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.12,341.77a3,3,0,0,1-.78-1.63.59.59,0,0,1,.29-.63.55.55,0,0,1,.75.17l0,.07a2.78,2.78,0,0,1,.68,1.78C310.78,342.05,310.41,342.07,310.12,341.77Z",
    transform: "translate(-154.83 -222.21)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.56,341a.93.93,0,0,1,0,1.12.74.74,0,0,1-.81.32.83.83,0,0,1-.61-.83C232.2,341,232.55,340.75,233.56,341Z",
    transform: "translate(-154.83 -222.21)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.49,272.76a.94.94,0,0,1-.9-1,.77.77,0,0,1,.06-.3.61.61,0,0,1,.49-.49.63.63,0,0,1,.67.21C252.2,271.63,252.2,272.1,251.49,272.76Z",
    transform: "translate(-154.83 -222.21)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.71,357.17a.48.48,0,0,1,.67,0c.22.18.29.52.11.64-.76.54-1.3,1.5-2.38,1.41a.37.37,0,0,1-.13.15c.28.67.53,1.18.72,1.71a2.48,2.48,0,0,1-.48,2.95,2.57,2.57,0,0,0-.65.91,1.49,1.49,0,0,1-1.51.89,3.66,3.66,0,0,1-2-.4c-.68-.36-1.16,0-1.51.66a.8.8,0,0,0-.09.31c.09.21.19.41.3.61,1.06,0,2-.17,2.73.84v-.07c.32.15.55.3.57.55l.25.15c.59.29,1,.69,1.66.67A.48.48,0,0,1,293,369a1.27,1.27,0,0,1,1.09-.29.6.6,0,0,1,.21-.14,4.21,4.21,0,0,0,0-.71,1.18,1.18,0,0,1,1-1.32h0c.61-.15.92,0,1.41.63a2.86,2.86,0,0,1,.51,1.2c.16.7.11.88-.43,1.27-1.23.88-1.48.83-2.38-.47-.1-.14-.18-.31-.31-.36v.09c-.06.88-.06,1.56-.16,2.29,0,0,.1,0,.1.11a1.05,1.05,0,0,1-.08.52l.14.19c.43.74.26,1.55.86,2.22h0v-.11c.78.65.84.7.54,1.28a1.34,1.34,0,0,1,0,.4l.07.89a1.37,1.37,0,0,0,1.17,1.54h.07a2,2,0,0,1,1.61,2h.17a3.18,3.18,0,0,1-.28,2.1h.1a1.52,1.52,0,0,1,.07.64.23.23,0,0,1,.21.09,4.33,4.33,0,0,0,.72,0h0V383a1.49,1.49,0,0,1,1.5,0,.51.51,0,0,0,.68-.21.36.36,0,0,0,0-.11c.11-.26.17-.54.48-.61v-1.24h-.06c0-.46.23-.63.51-.62a1.27,1.27,0,0,1,.27-.18,2.88,2.88,0,0,0,.19-.87h0l-.12.14c-.42-.11-.79-.14-.81-.54s.29-.48.62-.51a1.68,1.68,0,0,1,.67.05.7.7,0,0,1,.17-.13,1.27,1.27,0,0,1,.39,0l0-.1a.66.66,0,0,1,.76.15c.88.69,1.69.48,2.6-.18a1,1,0,0,1,.47.35,4.41,4.41,0,0,1,.23.64.62.62,0,0,0,0-.5,1,1,0,0,0,.82.27h0l-.09-.06c.18-.36.38-.42.65-.37s.65.08,1.1.18v-.24c.24-.49.49-.54.77-.29a.52.52,0,0,1,.15.65c-.12.34-.41.33-.73.24l-.08.18a.37.37,0,1,0-.64.36c-.19,1.68-.19,1.68-1.59,1.41a2.48,2.48,0,0,1-.59-.17l-.16.24a1.47,1.47,0,0,1-.27.66l.1.28c.19.43.34.8.67.79,1.1,0,2.26.19,3.36-.62h0l-.09-.09a8,8,0,0,1,1.57-.59c.36-.08.62.09.58.45l.13.11.09.11h0v-.13a2.31,2.31,0,0,1,1.09.91l.06-.11c.39,0,.64,0,.59.36s-.38.37-.67.19l-.15.09a1.75,1.75,0,0,1-.6-.05l.09.38-.08.1h.09a12.66,12.66,0,0,1-.62,2.64c0,.11-.22.19-.38.17l-.08.2a1.09,1.09,0,0,0-.14.31v.07h.07c.58,1.54.58,1.54-.89,1.44H312l-.15.12a1.31,1.31,0,0,1-1.12.19.14.14,0,0,1,0,.09h-.24s0,.06-.1.12a.31.31,0,0,1,.1.05c-.33.42-.6.47-.69,0a1.52,1.52,0,0,1-.28-.09c-.63-.39-1.14-.74-1.76-1.14v.1c-.51-.17-.51-.73-.79-1.08a.81.81,0,0,0-.46-.08,4.9,4.9,0,0,1-1.08-.06h-.17a.59.59,0,0,1,.17.1,3,3,0,0,1-1.77-.22,1.16,1.16,0,0,0-1.51.28,8.57,8.57,0,0,1-.82.77,4.73,4.73,0,0,0-.23.45.9.9,0,0,1-1,.54c-.46,0-.92-.07-1.52-.09v.06c-.37.42-.61.79-.92,1.08a.54.54,0,0,1-.76,0l-.07-.08c-.07-.09-.12-.21-.19-.32s-.16-.67-.53-.67a3.2,3.2,0,0,0-.9.26c-.33.1-.47.39-.67.63a.7.7,0,0,1-.84.23c-.37-.15-.32-.49-.4-.91l-.09.07a2,2,0,0,1-1-.2.33.33,0,0,1-.07.13l.08.1-.05.1c-.11.44-.08.84-.47.93a1.72,1.72,0,0,1-.11.29,3,3,0,0,0,.43,2.14v.12l.06-.2c.51,1.29.43,1.53-.53,1.92a2.46,2.46,0,0,1-.71.23,7.74,7.74,0,0,0-2.31.66,4.78,4.78,0,0,1-1,.19c-.08.06-.17.11-.25.18l-.48,2.44h.09c.32,1.07.32,1.07-.53,1.17a.73.73,0,0,1-.46-.07l-.24.12a9.12,9.12,0,0,1-1.48.06h0v.11c-.56.19-.91.08-.92-.43l-.19-.15a.93.93,0,0,1-.32-.11h0v.11a4.28,4.28,0,0,0-1.37.23.61.61,0,0,1-.68-.53.37.37,0,0,1,0-.11,4.75,4.75,0,0,1,.32-1.35c-.06,0-.11-.11-.17-.17l-.8-1.14h0v.1c-.39-.17-.71-.33-.28-.68l-.06-.22a4.05,4.05,0,0,0,0-1.1l-.08.1c-.64-.11-1.24.13-1.56-.39h-2.19a.27.27,0,0,1,.09.12c-.44.19-.62,0-.61-.32l-.25-.12a5.74,5.74,0,0,1-1.75-.2v.12a2,2,0,0,1-1.72.3,2.11,2.11,0,0,0-.23.19,8.92,8.92,0,0,1-1.62,2.42c-.11.11-.1.34-.15.67v.15l.13-.19a22.43,22.43,0,0,1,.41,2.71c.15.6-.06,1.23-.84,1.2l-.17.17a1.53,1.53,0,0,0-.47.41h0c-.15.33-.22.61-.5.62l-.15.2c-.56.65-1.06,1.19-1.62,1.82h.08c-.11.38-.24.66-.57.63l-.12.18a2.45,2.45,0,0,1-.71.43h0a.24.24,0,0,1,.09.06c-.7.26-1.31.41-1.91.58a2.45,2.45,0,0,1-2-.14,4.69,4.69,0,0,1-.6-.2h-.86v.06c-.45.48-.66.84-.13,1.2a3.52,3.52,0,0,1,.63.4,1,1,0,0,1,0,1.48l0,0c-.73.63-1.31.64-1.68-.12a4.05,4.05,0,0,0-1.85-1.94v-.12l-.07-.06-.08-.08v.06c-.31-.2-.44-.41-.32-.65l-.08-.28c-.09-.53-.11-.93-.17-1.45h-.05c-.41-.74-.77-1.41-1.06-2.07l-.43-.6c-.58-.52-1.19-.86-1.34-1.69h0l-.07.09c-.2-.29-.32-.53-.23-.76l-.09-.27a1.13,1.13,0,0,0-.28-.37H250.8l-.39.09a5.78,5.78,0,0,1-4.16-.73l-.26-.14c-.25-.1-.5-.21-.76-.34a1.19,1.19,0,0,0-.7,0,.71.71,0,0,1-.83-.33c-.26-.74-1-.53-1.43-1H242c-.47-.44-.52-.83-.12-1.19a.77.77,0,0,1,.5-.18.71.71,0,0,1,.79.62v0h.19c.9.37,1.16-.27,1.59-.55a.89.89,0,0,0,0-.32,3.74,3.74,0,0,0,.53-2.44v-.06l-.09.11a13.88,13.88,0,0,0-1.58,0c-.21,0-.36-.39-.26-.6a.83.83,0,0,1,1.08-.47h0c.4.13.56,0,.64-.4a1.53,1.53,0,0,1,.21-.51v-.34a7.53,7.53,0,0,1,0-1.08h0c-.05-.33-.11-.63.23-.66l.08-.25a1.52,1.52,0,0,1,1.72-.94h0l-.05-.07c.48-.12.86-.13,1,.27l.27.08a5.47,5.47,0,0,1,.66.09h0v-.07c.51-.18.92-.3,1.32-.41.16,0,.32-.07.39.12h.23c.91.41,1.69.81,2.57,1.29h0v-.12c.38.19.51.42.37.68l.08.27c.6.94,1.13,1.76,1.78,2.59h0a13,13,0,0,1,1.53,0,1.26,1.26,0,0,0,.38-.14l.3-.18h-.07c.34-.31.67-.43,1-.23h.31a4.34,4.34,0,0,0,.52-.09h-.07a2.05,2.05,0,0,1,1.33-.25,2.83,2.83,0,0,0,.41-.14c.39-.34.7-.59,1.07-.95h-.07c-.08-1,.13-1.57,1.06-1.73a3,3,0,0,0,.5-.17,3.51,3.51,0,0,1,.4-.27c.41-.42.73-.75,1.12-1.19h-.05c.15-.34.34-.5.59-.46l.27-.12a3.2,3.2,0,0,1,.56-.27l-.07-.06c.4-.3.68-.31.65.14a.94.94,0,0,1,.28.21c.71.45,1.17-.14,1.77,0,1.22.26,1.29.2,1.7-.84a2.18,2.18,0,0,1,1.37-1.42c.28-.1.51-.37.79-.49,1.15-.54,2.23-1.38,3.64-.48a2.41,2.41,0,0,0,2,0c.65-.24.85-.88.32-1.32a9.16,9.16,0,0,1-2.33-3.28h0a1.58,1.58,0,0,1-.89-1.68l-.18-.18a1,1,0,0,1-.14-.22v-.39a.34.34,0,0,1-.06.12c-.36-.49-.2-1.16-.81-1.33-.17,0-.27,0-.12-.11.59-.31.24-.74.18-1.14a.5.5,0,0,1,.3-.62c1-.21,1.38-1.06,2-1.5l.11-.31c.08-.17.17-.21.41-.23h-.07a9.69,9.69,0,0,1,3.7-1.44,7.37,7.37,0,0,0,2.19-1,.77.77,0,0,0,.38-1,.41.41,0,0,0-.05-.09c-.08-.17-.2-.32-.27-.49a2,2,0,0,1,.56-2.69l.11-.06c.49-.39,1.08-.26,1.72-.42h0v-.06a.85.85,0,0,1,.25-.17,1.28,1.28,0,0,0,.11-.24,3.57,3.57,0,0,1,.63-2.59c.82-1.4.83-1.41,2.52-1.28.68.06,1.35.19,2,.3.4.07.62.38.94.56h0C293.69,358.4,294.2,357.76,294.71,357.17Zm2.49,25.63a1.82,1.82,0,0,0,.5-.12h0l-.1-.06-.14.1a1.36,1.36,0,0,1-.49.12l.07.11A.46.46,0,0,1,297.2,382.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.7,390.14c-.3-.38-.31-.84-.06-1s.55.08.78.3c.46.42.51,1.29,1.38,1.29l.14.3c-.11,0-.25.13-.32.09-.42-.2-.69-.72-1.39-.62A1.77,1.77,0,0,1,356.7,390.14Z",
    transform: "translate(-154.83 -222.21)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.07,350.71a.67.67,0,0,1,.31-.42.46.46,0,0,1,.63.15v0a2.24,2.24,0,0,1,.32.66c.11.35.64,0,.57.5a4.29,4.29,0,0,0-.58.26c-.61.35-1,.27-1.15-.27A2.5,2.5,0,0,1,297.07,350.71Z",
    transform: "translate(-154.83 -222.21)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.52,435.87a1.7,1.7,0,0,1-1.19.22c-.51-.11-.66-.54-.32-1a1.61,1.61,0,0,1,.24-.28.89.89,0,0,1,1.17-.16A.74.74,0,0,1,158.52,435.87Z",
    transform: "translate(-154.83 -222.21)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.67,396.57a.57.57,0,0,1-.78-.2.6.6,0,0,1-.08-.35,1.35,1.35,0,0,1,.35-.83.85.85,0,0,1,1-.34c.42.16.44.53.29,1A3.34,3.34,0,0,1,339.67,396.57Z",
    transform: "translate(-154.83 -222.21)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.59,371a1,1,0,0,1,0,1.22c-.36.47-.78.18-1.28,0a.65.65,0,0,1-.19-.89l0,0a1.12,1.12,0,0,1,.67-.61A.74.74,0,0,1,309.59,371Z",
    transform: "translate(-154.83 -222.21)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.39,412.12a.75.75,0,0,1,.47-.89c.46-.16.87.15,1.07.74.12.32-.24.75.14.86a1.72,1.72,0,0,0-.64,0,.87.87,0,0,1-1-.67Z",
    transform: "translate(-154.83 -222.21)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.11,229.5a2,2,0,0,1-.36.79.6.6,0,0,1-.84.13.65.65,0,0,1-.21-.28,3.72,3.72,0,0,1-.14-.74c0-.63.37-.91,1-.71C271.88,228.8,272,229.05,272.11,229.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.2,260.14a.55.55,0,0,1-.78-.11l0,0a1.38,1.38,0,0,1,0-1.09c.15-.52.43-.56,1.18,0A1.33,1.33,0,0,1,316.2,260.14Z",
    transform: "translate(-154.83 -222.21)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.45,433.5a.86.86,0,0,1,1.72,0c.07.63-.32.88-1,.95C265.54,434.33,265.3,434,265.45,433.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.35,263.15c0-.66.18-1,.66-1.16a.43.43,0,0,1,.35,0,1.14,1.14,0,0,1,.36,1.31c-.12.44-.34.82-1,.56A1.79,1.79,0,0,1,290.35,263.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.2,416.63c.22.31.37.68,0,1a1.91,1.91,0,0,1-.72.34.91.91,0,0,1-.64-.73.75.75,0,0,1,.52-.87A.65.65,0,0,1,156.2,416.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.45,384.71a.72.72,0,0,1-.49-.87c.06-.23.28-.4.55-.65,1-.23,1.11-.17,1.06.46a2.41,2.41,0,0,1-.07.37A1.11,1.11,0,0,1,258.45,384.71Z",
    transform: "translate(-154.83 -222.21)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.69,377.87c.64.14,1.07.6,1,1.08a.64.64,0,0,1-.33.39,1,1,0,0,1-1.34-.45l0-.09c-.15-.22-.09-.46.11-.77A1.06,1.06,0,0,1,228.69,377.87Z",
    transform: "translate(-154.83 -222.21)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.89,334.85a.54.54,0,0,1-.33.1.88.88,0,0,1-.9-.86V334c0-.4.27-.66.68-1,.75-.11.74.39.83.79A1,1,0,0,1,347.89,334.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.71,390.54a.86.86,0,0,1,.73-.73c.42-.05.69.2.85.7a1.69,1.69,0,0,1-.31.73.75.75,0,0,1-1,.11A.71.71,0,0,1,366.71,390.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.12,412.46a4.69,4.69,0,0,1,.14-.65c.12-.34.17-.59.26-.81a.3.3,0,0,1,.38-.2l.07,0a1.29,1.29,0,0,1,.6,1.23,1.41,1.41,0,0,1-1.15.77.32.32,0,0,1-.3-.34Z",
    transform: "translate(-154.83 -222.21)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.81,332.14a.69.69,0,0,1,.58-.77h0a1,1,0,0,1,1,.67c.21.49,0,.82-.62,1A1,1,0,0,1,198.81,332.14Z",
    transform: "translate(-154.83 -222.21)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.55,297.4a2,2,0,0,1,.26.63.65.65,0,0,1-.23.66.71.71,0,0,1-.85,0,2.09,2.09,0,0,1-.5-.53.91.91,0,0,1,.12-1.28l0,0c.42-.23.68.09,1,.33A.92.92,0,0,1,251.55,297.4Z",
    transform: "translate(-154.83 -222.21)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.68,380.63c.49-.26.85-.2,1.06.19a1,1,0,0,1,0,1.07.86.86,0,0,1-1,.2C360.42,382,360.2,381.47,360.68,380.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.38,442.29a.81.81,0,0,1-1-.27.87.87,0,0,1,0-1c.39-.54.76-.12,1.22.15C169.91,441.63,169.91,442.08,169.38,442.29Z",
    transform: "translate(-154.83 -222.21)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.2,331.2c.21-.12.48,0,.74.28a1.51,1.51,0,0,1,.2.45c.09.46.05.89-.45,1.09a.65.65,0,0,1-.71,0,1.06,1.06,0,0,1-.23-1.21A1.16,1.16,0,0,1,287.2,331.2Z",
    transform: "translate(-154.83 -222.21)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.78,337.3c0,.05-.09.09-.24.19-.43.16-.73.13-.93-.17a1.24,1.24,0,0,1-.16-1.06.74.74,0,0,1,.9-.46C354,336,354.1,336.54,353.78,337.3Z",
    transform: "translate(-154.83 -222.21)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.71,353.2a4.48,4.48,0,0,1-.87-.3.92.92,0,0,1-.5-.94.8.8,0,0,1,.77-.82l.17,0a1.77,1.77,0,0,1,.78,1.72C330.05,353,330,353.27,329.71,353.2Z",
    transform: "translate(-154.83 -222.21)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.51,351.82a5.55,5.55,0,0,1-.82.06l.24-1.5a2.87,2.87,0,0,0-.12-.61l-.28-.1c-.87-1.24-.9-1.79-.3-2.52a.69.69,0,0,1,.81-.26c.42.14.86.31,1,.76a1.66,1.66,0,0,1-.45,2h.07a13.23,13.23,0,0,0,.42,1.35C326.2,351.35,326,351.7,325.51,351.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.08,360.06c0-.42.22-.71.79-.73a1,1,0,0,1,.57,1.29,1.06,1.06,0,0,1-.11.21.66.66,0,0,1-.9.28l-.05,0A1.12,1.12,0,0,1,325.08,360.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.36,414.15a.42.42,0,0,1-.05-.59l.05-.05a.56.56,0,0,1,.67-.15c.33.16.63.38.94.57a.63.63,0,0,1,.35.6c-.06.44-.36.6-.89.56A13.57,13.57,0,0,1,189.36,414.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.44,359.21l.32-.23c.74.33,1.6.32,1.83,1.32v.05l.15-.14c.74.14,1-.44,1.43-.61a2.51,2.51,0,0,1,2.46.37c.75.5.59,1.18.55,1.84a1,1,0,0,1-1,1.07,2.8,2.8,0,0,1-2.11-.55c-.5-.38-.54-.33-1.12.32a.4.4,0,0,1-.33.13V363c-.34.4-.65.64-1.2.39h0v.11a.9.9,0,0,1-.56-.09l-.2.09a1.11,1.11,0,0,1-1.16-.93v.08c-.25-.62-.39-1.15-.56-1.67a1.61,1.61,0,0,1,.39-1.51c.33-.47.8-.74,1.31-.33Z",
    transform: "translate(-154.83 -222.21)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.93,293.4a.61.61,0,0,1-.64.58.67.67,0,0,1-.36-.14,1.69,1.69,0,0,1-.41-.35.87.87,0,0,1-.18-1c.23-.38.6-.36,1.09-.15A1.21,1.21,0,0,1,239.93,293.4Z",
    transform: "translate(-154.83 -222.21)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339,416.63a4.48,4.48,0,0,0-1-1.25c-.34-.31-.15-.67.28-1,.29,0,.56,0,.62.08a16,16,0,0,1,.92,1.74.58.58,0,0,1-.17.48.4.4,0,0,1-.55.07A.58.58,0,0,1,339,416.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.8,399.74a.6.6,0,0,1-.59.59,2.68,2.68,0,0,1-.84-.13c-.39-.22-.6-.45-.49-.79a.72.72,0,0,1,.54-.46,1.22,1.22,0,0,1,.9.08A.72.72,0,0,1,166.8,399.74Z",
    transform: "translate(-154.83 -222.21)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.65,266.31a.77.77,0,0,1-.46.26.48.48,0,0,1-.55-.39,2,2,0,0,1,0-1.22c.23-.41.52-.61.8-.35A1.33,1.33,0,0,1,333.65,266.31Z",
    transform: "translate(-154.83 -222.21)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.27,387.8a1.3,1.3,0,0,0,.14-.32,1.58,1.58,0,0,1,.72-.27v-.12c.57-.13,1.08-.25,1.49.19l.26-.06a1.31,1.31,0,0,1,1,.35h0v-.07c.52.26,1.07.36,1.21.82l.27.22a1.65,1.65,0,0,1,.38.45h0v-.08c.33.57,1,.75,1,1.34.08,0,.16.09.25.13a1.69,1.69,0,0,1,.31,1.29v.12a.56.56,0,0,1,.1-.15,2,2,0,0,1,.35.84l.14.12.07.08,0,.07v-.12a3.05,3.05,0,0,1,.74,2,3.25,3.25,0,0,0,.15.4,7,7,0,0,1,0,1.12h0a1.1,1.1,0,0,1,0,.8v.36c.09,1.55-.3,2.72-1.82,3.37l-.06.05h.15c-.38.92-.82,1.65-1.66,1.8a2.22,2.22,0,0,1-.43.23,1.92,1.92,0,0,1-.58.16h-.06l.13.08c-1,.43-1.92.77-2.19,1.89a.69.69,0,0,1-.32.43,1.77,1.77,0,0,1-.68.19c-.24,0-.4-.11-.39-.34l-.21-.08c-.08,0-.17-.14-.26-.22l-.08-.08v.15c-.5-.13-.85-.26-1.22-.35-.72-.19-1.46-.33-2.17-.54a3.15,3.15,0,0,1-2.4-2.39,4.68,4.68,0,0,0-.77-1.7,4.19,4.19,0,0,1-.68-1.33,10.35,10.35,0,0,0-1.82-3.46c-1.16-1.66-.87-1.44.49-2.69.5-.45,1.07-.19,1.61-.07a1.75,1.75,0,0,0,2-.71,8.77,8.77,0,0,1,2.17-2.17,2.12,2.12,0,0,1,.34-.33l.12-.1h-.06A10.09,10.09,0,0,1,228.27,387.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.2,356.52c.12.11-.1.46-.38.55s-.54,0-.58-.3.13-.75,0-1-.64-.39-.65-.84a1,1,0,0,1,.14-.46c.34-.22.62-.2.74,0C305.84,355.12,305.66,355.94,306.2,356.52Z",
    transform: "translate(-154.83 -222.21)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.86,406.82c.55.22,1.07.11,1.46.51a.7.7,0,0,1,0,1,1,1,0,0,1-1,.11.77.77,0,0,1-.48-.71C177.8,407.38,178.2,407,177.86,406.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.54,434.84a3.93,3.93,0,0,1,.14.91.59.59,0,0,1-.3.42.52.52,0,0,1-.66-.15,1.65,1.65,0,0,1-.29-1.16C221.2,434.08,221.38,434.09,221.54,434.84Z",
    transform: "translate(-154.83 -222.21)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.35,285.34a.61.61,0,0,1,.75.42.59.59,0,0,1,0,.13,2.22,2.22,0,0,1-.58,1.82c-1-.18-1.31-.57-1.25-1.26A1.27,1.27,0,0,1,362.35,285.34Z",
    transform: "translate(-154.83 -222.21)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364,385.15c-.51-.2-.64-.64-.38-1.35,0-.06.07-.1.2-.22.93,0,1.16.24,1.06.84S364.32,385.29,364,385.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.62,352.1a.68.68,0,0,1-.27.92.74.74,0,0,1-.41.08,1.89,1.89,0,0,1-.73-.41c-.3-.53-.3-.93.21-1.17s.71,0,1,.3A1.1,1.1,0,0,1,203.62,352.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.38,328.44a.92.92,0,0,1-.08-1.18c.31-.31.76-.2,1.25.33a.81.81,0,0,1,.05.76.69.69,0,0,1-.77.37A.79.79,0,0,1,270.38,328.44Z",
    transform: "translate(-154.83 -222.21)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.2,347a.73.73,0,0,1-.13.86.72.72,0,0,1-1.28-.63.71.71,0,0,1,.63-.59A.73.73,0,0,1,350.2,347Z",
    transform: "translate(-154.83 -222.21)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182,426.18a.81.81,0,0,1-1.13.09l0,0c-.24-.3-.15-.75.26-1.12.08-.08.23-.08.47-.11C182.27,425.5,182.35,425.81,182,426.18Z",
    transform: "translate(-154.83 -222.21)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204,427.28a.84.84,0,0,1-.06.89.61.61,0,0,1-.76.4.72.72,0,0,1-.24-.14,1.09,1.09,0,0,1-.17-1.16.7.7,0,0,1,.62-.37A.65.65,0,0,1,204,427.28Z",
    transform: "translate(-154.83 -222.21)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.87,376.44c.32.36.33.68,0,.95a.65.65,0,0,1-1,0,1.66,1.66,0,0,1-.23-.41c-.13-.43-.06-.73.23-.9S238.62,376.16,238.87,376.44Z",
    transform: "translate(-154.83 -222.21)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.93,399.51a.7.7,0,0,1-.69.17,1,1,0,0,1-.59-.67c-.1-.33-.09-.65.24-.82a.9.9,0,0,1,1.22.35.92.92,0,0,1,.09.23,1.54,1.54,0,0,1-.07.49A1.16,1.16,0,0,1,317.93,399.51Z",
    transform: "translate(-154.83 -222.21)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.49,374c-.1.42-.53.54-1.25.34-.11,0-.21-.13-.38-.32s-.13-.23-.11-.29c.19-.76.57-1.07,1.07-.9A1,1,0,0,1,359.49,374Z",
    transform: "translate(-154.83 -222.21)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.42,333.88a2.06,2.06,0,0,1,.24.64c0,.65-.31,1-.83.93a1,1,0,0,1-.84-.66.91.91,0,0,1,.46-1.11.63.63,0,0,1,.89.07A.57.57,0,0,1,272.42,333.88Z",
    transform: "translate(-154.83 -222.21)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.45,365.75a.73.73,0,0,1-.88.49.84.84,0,0,1-.5-1,1.1,1.1,0,0,1,1.29-.89l.09,0-.07-.1a2.55,2.55,0,0,1-.31-1.75,1.69,1.69,0,0,1,1.72-1.39,2,2,0,0,1,1.59,1.11.43.43,0,0,1,0,.35c-.73.78-1.24,1.87-2.63,1.93v.08C352.63,365.05,352.57,365.42,352.45,365.75Z",
    transform: "translate(-154.83 -222.21)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.83,423.51a.71.71,0,0,1-.87,0,.76.76,0,0,1-.35-.8.89.89,0,0,1,.87-.71,2.19,2.19,0,0,1,.52.65A.63.63,0,0,1,244.83,423.51Z",
    transform: "translate(-154.83 -222.21)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.06,374.15c.24-.13.48,0,.79.17s.7.45,1,.66v.33a17.47,17.47,0,0,1-1.89-.25C222.61,375,222.71,374.33,223.06,374.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321,317.31c-.13-.45-.19-.89.25-1.19a.59.59,0,0,1,.52,0,.79.79,0,0,1,.41.94,1.72,1.72,0,0,1-.13.48C321.4,317.81,321.15,317.73,321,317.31Z",
    transform: "translate(-154.83 -222.21)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.57,337.58a.78.78,0,0,1,1,0,.78.78,0,0,1,.2,1,.65.65,0,0,1-.87.29.66.66,0,0,1-.36-.52A1.82,1.82,0,0,1,257.57,337.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.15,255.25a.89.89,0,0,1-1-.69.43.43,0,0,0,0-.05.65.65,0,0,1,.57-.71h.1c.21,0,.4.23.67.46C329.64,254.75,329.61,255.13,329.15,255.25Z",
    transform: "translate(-154.83 -222.21)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.08,348.07a.68.68,0,0,1-1,.08l0,0a.77.77,0,0,1-.27-.93c.35-.38.7-.49,1.07-.26a.75.75,0,0,1,.26,1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.49,420.8a.71.71,0,0,1,.74-.66.69.69,0,0,1,.63.76,1.09,1.09,0,0,1-.58.8.81.81,0,0,1-.8-.78S272.49,420.84,272.49,420.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216,327.36a.76.76,0,0,1-.25.81.73.73,0,0,1-.93-.12.87.87,0,0,1-.16-.79.81.81,0,0,1,.62-.59C215.56,326.63,215.92,327,216,327.36Z",
    transform: "translate(-154.83 -222.21)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.65,274.54c.32-.21.59-.09.78.37a1.94,1.94,0,0,1-.06.68c-.22.6-.57.82-.93.64a.84.84,0,0,1-.28-1.15A1.5,1.5,0,0,1,359.65,274.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.93,336.18a.65.65,0,0,1,.48.5,1,1,0,0,1-.38,1c-.26.24-.54.23-.91,0a1.15,1.15,0,0,1,.15-1.29A.58.58,0,0,1,297.93,336.18Z",
    transform: "translate(-154.83 -222.21)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.29,461.7a1.24,1.24,0,0,1-.7.38c-.22-.11-.36-.16-.42-.26-.3-.48-.26-.84.12-1.13a.63.63,0,0,1,.87,0A.79.79,0,0,1,261.29,461.7Z",
    transform: "translate(-154.83 -222.21)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.58,396.94a.55.55,0,0,1-.54-.43c-.18-.73.21-1,1.33-.9a.73.73,0,0,1,0,1A1,1,0,0,1,311.58,396.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.07,347.29c.16-.66-.58-1-.49-1.61a3.42,3.42,0,0,1,1.6,1.12.72.72,0,0,1-.06.72.56.56,0,0,1-.62.3A.5.5,0,0,1,378.07,347.29Z",
    transform: "translate(-154.83 -222.21)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.86,409.32a.59.59,0,0,1-.71.43h0a.79.79,0,0,1-.65-.78.69.69,0,0,1,.67-.71h0c.22,0,.43.2.7.42A1.27,1.27,0,0,1,363.86,409.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.85,400.63a3.39,3.39,0,0,1-.18,1c-.5.35-.77.12-1-.22a.8.8,0,0,1,.06-1,1,1,0,0,1,.66-.27A.49.49,0,0,1,326.85,400.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.14,332.74a.76.76,0,0,1,.24-.47.56.56,0,0,1,.69,0,.88.88,0,0,1,.48.92c-.07.35-.38.45-.82.47A.86.86,0,0,1,224.14,332.74Z",
    transform: "translate(-154.83 -222.21)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389,311.2a.89.89,0,0,1,1-.59c.38.06.46.34.4.79-.22.48-.49.71-.9.7a.74.74,0,0,1-.46-.22A.6.6,0,0,1,389,311.2Z",
    transform: "translate(-154.83 -222.21)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.51,390.5c-.23-.68-.88-.85-1.26-1.32a.57.57,0,0,1,0-.81l0,0c.29-.29.55-.13.87.19C305.64,389.15,306.2,389.63,305.51,390.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.46,373.31a1.25,1.25,0,0,1,1-.27c.32,0,.62.17.67.52s-.21.55-.5.68a2.23,2.23,0,0,1-.51.19.68.68,0,0,1-.67-.21C369.2,374,369.2,373.69,369.46,373.31Z",
    transform: "translate(-154.83 -222.21)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.62,342.53a.52.52,0,0,1,.4.57,5,5,0,0,1-.3,1.2l.19.13c.43.62,1,1.1.5,1.85h0l.14.08c0,.55.42.71.63,1a.81.81,0,0,1,0,1.15.7.7,0,0,1-.83.16.84.84,0,0,1-.48-1.06c0-.17.19-.35.17-.51s-.16-.29-.22-.54a.26.26,0,0,0-.21.08c-1.31-1-1.36-1.25-.4-2.36l-.12-.07c-.16-.49-.34-.83-.17-1.22S299.28,342.45,299.62,342.53Z",
    transform: "translate(-154.83 -222.21)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273,401.63a.65.65,0,0,1,.73-.42.8.8,0,0,1,.64.58c.15.49-.12.74-1.09.88a.74.74,0,0,1-.3-1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.55,354.81a1.34,1.34,0,0,1-.08-1.4h-.06a8.63,8.63,0,0,1-1.06-.62.59.59,0,0,1-.13-.48c.06-.26.31-.34.56-.35a.64.64,0,0,1,.69.48,5.57,5.57,0,0,1,0,1,.2.2,0,0,0,.13.06.91.91,0,0,1,1,.81.6.6,0,0,1,0,.19.59.59,0,0,1-.41.55A.55.55,0,0,1,276.55,354.81Z",
    transform: "translate(-154.83 -222.21)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.46,320.78a.61.61,0,0,1-.52.69.62.62,0,0,1-.6-.28,1.5,1.5,0,0,1-.19-.32c-.14-.35-.25-.73.14-1s.59,0,.93.28A1.72,1.72,0,0,1,236.46,320.78Z",
    transform: "translate(-154.83 -222.21)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.77,387.41a.64.64,0,0,1,.38-.59.75.75,0,0,1,1,.09c.3.32.24.65-.18,1a.89.89,0,0,1-.81,0A.6.6,0,0,1,259.77,387.41Z",
    transform: "translate(-154.83 -222.21)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.28,406.18c.25-.39.57-.65,1.11-.2a1.65,1.65,0,0,1,.18.62.63.63,0,0,1-.55.62.62.62,0,0,1-.65-.19A.72.72,0,0,1,366.28,406.18Z",
    transform: "translate(-154.83 -222.21)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314,395.16a1.07,1.07,0,0,1,.47-.05c.31.1.61.26.52.65s-.3.72-.75.72-.52-.3-.59-.62S313.64,395.38,314,395.16Z",
    transform: "translate(-154.83 -222.21)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.82,429.09c-.08.38-.4.43-.73.38a.56.56,0,0,1-.5-.6s0,0,0-.06c.06-.51.3-.64,1.12-.54A1.89,1.89,0,0,1,163.82,429.09Z",
    transform: "translate(-154.83 -222.21)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.9,490.63a.63.63,0,0,1-.52.72h-.12c-.48-.05-.85-.24-.66-.92a.86.86,0,0,1,.71-.38.55.55,0,0,1,.59.51Z",
    transform: "translate(-154.83 -222.21)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.51,381.82c-.26-.49,0-.81.57-1,.73.3.6.9.66,1.42,0,.1-.08.29-.16.3a.72.72,0,0,1-.5,0A2.33,2.33,0,0,1,416.51,381.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.11,285c0,.45-.05.73-.44.8a.64.64,0,0,1-.63-.31c-.31-.46-.31-1,.06-1.16C216.64,284.1,216.9,284.48,217.11,285Z",
    transform: "translate(-154.83 -222.21)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.94,290.42a1.14,1.14,0,0,1,.24-.43.68.68,0,0,1,1-.11s0,0,0,0a.82.82,0,0,1,0,1.16,1,1,0,0,1-.65.28C334.08,291.31,333.91,291,333.94,290.42Z",
    transform: "translate(-154.83 -222.21)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.72,347.05a.64.64,0,0,1-.89,0,1,1,0,0,1-.11-.17,1.79,1.79,0,0,1,.32-1.33.41.41,0,0,1,.55-.14.41.41,0,0,1,.17.22,2.64,2.64,0,0,1,.28.67A.72.72,0,0,1,369.72,347.05Z",
    transform: "translate(-154.83 -222.21)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.62,346.91a.71.71,0,0,1,.27,1l0,0a.68.68,0,0,1-.46.25.88.88,0,0,1-.73-.94C290.74,346.75,291.12,346.74,291.62,346.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345,330.74a.74.74,0,0,1-.85.18c-.4-.2-.46-.54-.26-1a1.61,1.61,0,0,1,.35-.34.52.52,0,0,1,.74.11.22.22,0,0,1,.05.08A.76.76,0,0,1,345,330.74Z",
    transform: "translate(-154.83 -222.21)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.64,341.32a.64.64,0,0,1,.68-.18.68.68,0,0,1,.44.76c-.07.57-.36.93-1.12.76C307.2,341.87,307.2,341.63,307.64,341.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.38,309.7c.1.32,0,.59-.39.86a.65.65,0,0,1-.83-.39.65.65,0,0,1,0-.19c-.12-.56.07-1.06.38-1.09S268.2,309.21,268.38,309.7Z",
    transform: "translate(-154.83 -222.21)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.56,315.19c.05-.68.51-.92,1.22-1,.39.76.32,1.08-.26,1.55a.54.54,0,0,1-.68.06A.73.73,0,0,1,391.56,315.19Z",
    transform: "translate(-154.83 -222.21)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.8,406.77Z",
    transform: "translate(-154.83 -222.21)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.62,406.85c.52.15.75.5.62.92a.68.68,0,0,1-.66.51c-.44,0-.71-.26-.76-.81v-.68h.12C254.26,406.87,254.45,406.8,254.62,406.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.61,354.84a.92.92,0,0,1,.14-1,.7.7,0,0,1,.69-.17.83.83,0,0,1,.54,1,.67.67,0,0,1-.48.52C289.2,355.35,288.91,355.19,288.61,354.84Z",
    transform: "translate(-154.83 -222.21)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.09,323.54c-1.1-.42-1.22-.58-.88-1.33.16-.36.13-1.06.62-1s.26.7.32,1.08a9.3,9.3,0,0,1,.07,1.29Z",
    transform: "translate(-154.83 -222.21)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,451.82a1.58,1.58,0,0,1,.54-.42c.55-.15,1,0,1.09.4s-.26.78-.79.86a1.57,1.57,0,0,1-.71-.1C172.82,452.46,172.82,452.19,173,451.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.12,349.06c-.22.36-.53.49-1,.13a1.07,1.07,0,0,1-.2-1,.59.59,0,0,1,.54-.42.64.64,0,0,1,.65.24A.92.92,0,0,1,329.12,349.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.71,352.1c-.09-.38.27-.75.77-.86s.78.16.72.73a1.3,1.3,0,0,1-.35.54C394.28,352.63,393.85,352.63,393.71,352.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.32,412.71a.81.81,0,0,1,.53-.06c.26,0,.35.31.43.55a1.5,1.5,0,0,1,0,.3c0,.18,0,.26-.08.29-.49.37-.85.39-1.09.06a.8.8,0,0,1,.18-1.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.86,349.28a.54.54,0,0,1-.26.74l0,0a.6.6,0,0,1-.8-.21,1.1,1.1,0,0,1-.13-1.13.86.86,0,0,1,1.22.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.09,347.5a.53.53,0,0,1-.08.28c-.69.4-.95.38-1.07,0a.77.77,0,0,1,.35-1l0,0C296.71,346.63,297,346.89,297.09,347.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.6,341.27c-.17-.64.14-.92,1.18-.93a1,1,0,0,1,0,1.15.6.6,0,0,1-.64.29A.72.72,0,0,1,367.6,341.27Z",
    transform: "translate(-154.83 -222.21)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.2,402.63a.6.6,0,0,1-.67.16,1.64,1.64,0,0,1-.5-.41.94.94,0,0,1,0-.47c.08-.3.18-.61.56-.63a.81.81,0,0,1,.72.5A.68.68,0,0,1,351.2,402.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.41,461.85a.64.64,0,0,1-.69.08.51.51,0,0,1-.27-.61,1.08,1.08,0,0,1,.68-.92C203.85,461.09,203.9,461.5,203.41,461.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.67,437.86a.54.54,0,0,1-.4.56.51.51,0,0,1-.59-.29.87.87,0,0,1,0-1.1C283.63,437,283.77,437.16,283.67,437.86Z",
    transform: "translate(-154.83 -222.21)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.6,340.36a.85.85,0,0,1-.13-1c.19-.42.5-.49,1-.2a.9.9,0,0,1,.08,1.12.6.6,0,0,1-.83.18Z",
    transform: "translate(-154.83 -222.21)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.72,349c.47,0,.59.38.57.79a1.6,1.6,0,0,1,0,.31c-.14.19-.23.32-.33.33-.59,0-.89-.23-.88-.69A.71.71,0,0,1,308.72,349Z",
    transform: "translate(-154.83 -222.21)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.05,310.23a.66.66,0,0,1,.78.34,1,1,0,0,1,0,.9c-.12.25-.36.31-.74.25a1,1,0,0,1-.39-.91C298.71,310.55,298.77,310.31,299.05,310.23Z",
    transform: "translate(-154.83 -222.21)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.49,374.1c-.31.44-.64.5-1,.28a.65.65,0,0,1-.28-.86.43.43,0,0,1,0-.07.61.61,0,0,1,.81-.19C160.37,373.4,160.48,373.63,160.49,374.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.57,447.52a.65.65,0,0,1,.27-.81c.3-.17.6-.15.86.27a1.72,1.72,0,0,1,0,.64.55.55,0,0,1-.59.37A.61.61,0,0,1,367.57,447.52Z",
    transform: "translate(-154.83 -222.21)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.69,272.1a.74.74,0,0,1-.23.2c-.79-.22-.95-.44-.78-.91a.63.63,0,0,1,.76-.45l.12.05a.69.69,0,0,1,.25,1A.79.79,0,0,1,295.69,272.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.75,406.12a.61.61,0,0,1-.47.17.74.74,0,0,1-.51-.87c.1-.48.48-.47.94-.23A.69.69,0,0,1,197.75,406.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.45,343.63c-.83.23-1.15.11-1.15-.35a.57.57,0,0,1,.51-.63h0C252.36,342.55,252.54,342.8,252.45,343.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.26,349a.9.9,0,0,1-.43-1.1c.1-.38.42-.38.86-.3.6.78.61.93.24,1.28A.58.58,0,0,1,367.26,349Z",
    transform: "translate(-154.83 -222.21)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.49,355.63a.68.68,0,0,1,.64-.44.58.58,0,0,1,.6.33.72.72,0,0,1-.15.84.63.63,0,0,1-.67.1C283.57,356.37,283.48,356.1,283.49,355.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.13,383.06a.62.62,0,0,1-.73.43.78.78,0,0,1-.42-.32.7.7,0,0,1,.15-.86c.31-.31.84-.27,1.1-.69,0,0,0,0,0,.18A6.77,6.77,0,0,1,318.13,383.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.89,259.32a.59.59,0,0,1-.36.74c-.34.11-.55-.12-.68-.53a.53.53,0,0,1,.45-.75C250.66,258.74,250.84,259,250.89,259.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.15,327.07a1.46,1.46,0,0,1,.05-.72c.09-.24.34-.33.72-.32a.66.66,0,0,1,.32.89l-.07.11a.76.76,0,0,1-.43.31.45.45,0,0,1-.58-.24A0,0,0,0,0,390.15,327.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.61,353.94a.57.57,0,0,1-.16.68.47.47,0,0,1-.64-.16h0c-.19-.24-.35-.5-.6-.84.12-.24-.31-.21-.07-.27C252.92,353.16,253.4,353.34,253.61,353.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.28,322.16c.16-.32.26-.7.84-.66a.86.86,0,0,1,.29,1.17l0,.05a.71.71,0,0,1-.95.27A.66.66,0,0,1,384.28,322.16Z",
    transform: "translate(-154.83 -222.21)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.27,443.87a.74.74,0,0,1-.16.27c-.77.16-1,0-1-.36a.82.82,0,0,1,.72-.91h0C284.2,442.84,284.34,443.15,284.27,443.87Z",
    transform: "translate(-154.83 -222.21)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344,347.48c-.08.34-.36.47-.81.41-.36-.27-.49-.54-.36-.86a.77.77,0,0,1,.51-.5.45.45,0,0,1,.6.21v0A1.32,1.32,0,0,1,344,347.48Z",
    transform: "translate(-154.83 -222.21)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.45,414a.7.7,0,0,1,.75-.64c.39,0,.53.33.5,1a2,2,0,0,1-.18.24C363.71,414.63,363.43,414.45,363.45,414Z",
    transform: "translate(-154.83 -222.21)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.55,304.37c.07-.15.25-.25.5-.4a1.06,1.06,0,0,1,.6.21.64.64,0,0,1,.09.91l-.09.09a.56.56,0,0,1-.68.12.68.68,0,0,1-.46-.83A1,1,0,0,1,396.55,304.37Z",
    transform: "translate(-154.83 -222.21)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.13,357.35a4.44,4.44,0,0,1-.18-.88.33.33,0,0,1,.24-.39h.05a.74.74,0,0,1,.47.18,1.64,1.64,0,0,1,.25.61.77.77,0,0,1,.06.3.52.52,0,0,1-.37.57A.47.47,0,0,1,276.13,357.35Z",
    transform: "translate(-154.83 -222.21)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.89,403.82a.54.54,0,0,1,.64-.25.6.6,0,0,1,.36.75,2,2,0,0,1-.86.91l.12.12a7.62,7.62,0,0,1,.6,1.74l.08-.08c.12.43.08.74-.32.67a1.3,1.3,0,0,1-.19.22,7.73,7.73,0,0,1-1.18.25l.05.06c-.6.16-1.14.29-1.26-.35l-.18-.18a2,2,0,0,1,0-1.38,3.61,3.61,0,0,1,.68-1c.32-.32.77-.16,1.28-.17v-.07C275.82,404.54,275.66,404.15,275.89,403.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.61,418.85a.45.45,0,0,1-.13.63l0,0c-.34.2-.66,0-1-.55a.88.88,0,0,1,.06-.28C191.05,418.16,191.37,418.4,191.61,418.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.41,362.85a.68.68,0,0,1-.8.32.62.62,0,0,1-.44-.54.66.66,0,0,1,.4-.76c.25-.11.48,0,.77.2A.66.66,0,0,1,341.41,362.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.09,290.31c-.19.48-.55.6-1.09.31-.11-.12-.15-.18-.15-.23a.73.73,0,0,1,.69-.75h.13a.5.5,0,0,1,.44.57A.29.29,0,0,1,214.09,290.31Z",
    transform: "translate(-154.83 -222.21)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.2,396a.65.65,0,0,1,.88.23,1,1,0,0,1,0,.1c.12.45-.14.68-.56.77a.76.76,0,0,1-.3,0C214.87,396.36,214.88,396.11,215.2,396Z",
    transform: "translate(-154.83 -222.21)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.09,311.88a.53.53,0,0,1-.66-.38.24.24,0,0,1,0-.08.71.71,0,0,1,.44-.89l.1,0a.81.81,0,0,1,.64.7.58.58,0,0,1-.48.66Z",
    transform: "translate(-154.83 -222.21)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.05,390.13a.52.52,0,0,1-.16.73l-.1.05c-.44.23-.69.07-1-.74.25-.39.52-.54.85-.41A.78.78,0,0,1,180.05,390.13Z",
    transform: "translate(-154.83 -222.21)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.38,321.94c.36-.4.68-.46.93,0s.16.8-.17.93a.59.59,0,0,1-.82-.45A1,1,0,0,1,322.38,321.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.89,414.55c-.28.08-.49.17-.63.11-.43-.18-.6-.54-.47-.85a.69.69,0,0,1,.92-.34h0C226.2,413.63,226.3,414,225.89,414.55Z",
    transform: "translate(-154.83 -222.21)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.93,405.81a5.43,5.43,0,0,1-.16.88l-.09-.07c-.55-.2-.89-.45-.94-.94a.48.48,0,0,1,.68-.54A.62.62,0,0,1,177.93,405.81Z",
    transform: "translate(-154.83 -222.21)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.94,350.58a1.87,1.87,0,0,1,.13.71.51.51,0,0,1-.49.54.55.55,0,0,1-.28-.06c-.2-.09-.33-.32-.51-.62a1.4,1.4,0,0,1,.19-.63C304.31,350.07,304.75,350.1,304.94,350.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351,361.63c-.22.36-.56.44-1.08.39-.45-.26-.41-.54-.2-.81a.92.92,0,0,1,.93-.46.61.61,0,0,1,.39.78A.3.3,0,0,1,351,361.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.53,391.47c.12-.11.34-.11.63-.11.22.2.38.35.4.51a.67.67,0,0,1-.57.77h-.05a.7.7,0,0,1-.48-.18.67.67,0,0,1,0-1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.12,424.3a.5.5,0,0,1-.64-.08.71.71,0,0,1,.08-1c.3-.34.61-.31.91.18C273.49,423.85,273.43,424.14,273.12,424.3Z",
    transform: "translate(-154.83 -222.21)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.57,306.63a.72.72,0,0,1,.83-.43.56.56,0,0,1,.4.3c.15.36-.19.83-.68.92S368.49,307.13,368.57,306.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.12,277.76c-.18.33-.49.28-.86,0-.32-.44-.27-.78.06-1a.59.59,0,0,1,.48-.1A.84.84,0,0,1,316.12,277.76Z",
    transform: "translate(-154.83 -222.21)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.15,343.15a1.54,1.54,0,0,1-.31.56.53.53,0,0,1-.75,0l0-.05a.65.65,0,0,1,0-.83C295.34,342.43,295.68,342.51,296.15,343.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.41,267.93a.65.65,0,0,1-.88.31l-.12-.07a.73.73,0,0,1-.2-1,.64.64,0,0,1,.9-.1l.1.1A1.2,1.2,0,0,1,198.41,267.93Z",
    transform: "translate(-154.83 -222.21)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.08,451.63c.12.38-.07.83-.4.87-.49,0-.57-.34-.65-.7a1.22,1.22,0,0,1,0-.27C161.74,451.17,162,451.22,162.08,451.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.2,416.63a.55.55,0,0,1,.06-.78l.06,0a1.37,1.37,0,0,1,.88-.18c.18.5.22.87-.18,1.1a.58.58,0,0,1-.81-.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.15,266a.58.58,0,0,1-.64-.24.72.72,0,0,1,.07-.86.78.78,0,0,1,.77-.25.69.69,0,0,1,.37.71A.71.71,0,0,1,355.15,266Z",
    transform: "translate(-154.83 -222.21)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.4,420.82a.75.75,0,0,1,0-.47c.13-.2.21-.31.32-.35a.57.57,0,0,1,.78.2.48.48,0,0,1,.07.2.74.74,0,0,1-.28.81C388,421.42,387.71,421.29,387.4,420.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.07,414.77c0,.14-.11.43-.22.44-.51.1-1.11.36-1.36-.53a1.13,1.13,0,0,1,1.27-.3A.52.52,0,0,1,317.07,414.77Z",
    transform: "translate(-154.83 -222.21)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.2,269.76a.53.53,0,0,1-.32.6.55.55,0,0,1-.66-.19c-.35-.4-.31-.57.39-1.17A.84.84,0,0,1,220.2,269.76Z",
    transform: "translate(-154.83 -222.21)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.92,379.63c-.22-.06-.37-.08-.43-.17-.38-.45-.27-.84.23-.92.31,0,.64,0,.78.3S193.46,379.49,192.92,379.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.78,372.82c-.11.06-.24,0-.48,0-.19-.19-.34-.35-.35-.51,0-.37.26-.55.58-.63a.47.47,0,0,1,.57.34v0a.56.56,0,0,1-.27.76Z",
    transform: "translate(-154.83 -222.21)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.83,265.82a.58.58,0,0,1,.8.22.47.47,0,0,1,.06.15c.13.47,0,.63-.88.89C396.38,266.24,396.4,266.05,396.83,265.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.77,419.55a1.26,1.26,0,0,1-.11-.63c.21-.32.43-.42.7-.36a.56.56,0,0,1,.43.54.57.57,0,0,1-.36.59.45.45,0,0,1-.63-.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.91,390.91a.55.55,0,0,1,.61.3c.17.27.22.58-.1.79a1,1,0,0,1-.6.11,1.21,1.21,0,0,1-.34-.52.55.55,0,0,1,.37-.67Z",
    transform: "translate(-154.83 -222.21)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.49,369.16a.5.5,0,0,1,.53-.47.42.42,0,0,1,.16,0c.46.15.52.48.3.88,0,.05-.1.09-.25.17C411.64,369.86,411.41,369.63,411.49,369.16Z",
    transform: "translate(-154.83 -222.21)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.61,363.1a.58.58,0,0,1,.73-.36l0,0c.11,0,.19.15.34.33a1,1,0,0,1-.1.61.59.59,0,0,1-.83.05h0a.48.48,0,0,1-.16-.65Z",
    transform: "translate(-154.83 -222.21)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.1,414.83a.56.56,0,0,1-.69,0,.68.68,0,0,1-.19-.85c.2-.45.56-.41,1-.14C323.57,414.28,323.46,414.63,323.1,414.83Z",
    transform: "translate(-154.83 -222.21)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.29,431.22a.55.55,0,0,1,.66-.41l.06,0a.63.63,0,0,1,.35.38.58.58,0,0,1-.36.73h0a1,1,0,0,1-.62-.12A1,1,0,0,1,256.29,431.22Z",
    transform: "translate(-154.83 -222.21)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.13,415.33l-.22-.66c-.07-.23-.16-.48.11-.65a.8.8,0,0,1,.71,0,.57.57,0,0,1,.36.58.68.68,0,0,1-.42.74l-.52.16S355.15,415.47,355.13,415.33Z",
    transform: "translate(-154.83 -222.21)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.14,409.81a.6.6,0,0,1-.26.65.63.63,0,0,1-.85-.12,1,1,0,0,1-.12-.64c.21-.21.36-.36.53-.38a.59.59,0,0,1,.7.46Z",
    transform: "translate(-154.83 -222.21)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.08,425.84c.56.14.7.46.48.84a.51.51,0,0,1-.71.18l-.09-.06C344.42,426.58,344.48,426.32,345.08,425.84Z",
    transform: "translate(-154.83 -222.21)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.41,356.85a1.22,1.22,0,0,1-.33.54,1.2,1.2,0,0,1-.61-.15.55.55,0,0,1-.18-.76l0-.05a.57.57,0,0,1,.63-.27.57.57,0,0,1,.45.68Z",
    transform: "translate(-154.83 -222.21)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.28,412a6.16,6.16,0,0,1-.33,1,.35.35,0,0,1-.28.15.35.35,0,0,1-.22-.24,5.84,5.84,0,0,1-.08-.93c0-.25.07-.53.38-.55S316.2,411.63,316.28,412Z",
    transform: "translate(-154.83 -222.21)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.49,361.1a.45.45,0,0,1-.14.63l0,0a1.22,1.22,0,0,1-.62.16,1.3,1.3,0,0,1-.32-.54.48.48,0,0,1,.32-.6h0A.62.62,0,0,1,228.49,361.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.06,274.36a.57.57,0,0,1-.08.8l0,0a1.2,1.2,0,0,1-.62.13.64.64,0,0,1-.35-.7.61.61,0,0,1,.46-.53A.55.55,0,0,1,262.06,274.36Z",
    transform: "translate(-154.83 -222.21)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.78,335.05c.32-.11.72.21.77.61a.61.61,0,0,1-.14.5c-.23.26-.55.19-1,0A.72.72,0,0,1,167.78,335.05Z",
    transform: "translate(-154.83 -222.21)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201,394c.13.46,0,.84-.35.84a.69.69,0,0,1-.72-.64h0c-.06-.47.15-.67.73-.51C200.85,393.84,201,393.91,201,394Z",
    transform: "translate(-154.83 -222.21)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.59,419.15a.87.87,0,0,1,.41-.22c.21.06.35.1.41.19a.57.57,0,0,1,0,.82l-.16.1a.49.49,0,0,1-.66-.07.58.58,0,0,1,0-.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.51,435.07a.76.76,0,0,1-.26.16.57.57,0,0,1-.74-.31.73.73,0,0,1,.32-.92.63.63,0,0,1,.81.38.29.29,0,0,1,0,.09C246.72,434.63,246.62,434.81,246.51,435.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.29,329.1a.45.45,0,0,1,.44-.46h0a.62.62,0,0,1,.65.55.69.69,0,0,1-.13.43.8.8,0,0,1-.43.13A.64.64,0,0,1,217.29,329.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.2,378.44c-.07.37-.23.54-.49.58a.57.57,0,1,1-.34-1.09C182.78,377.73,183.05,377.93,183.2,378.44Z",
    transform: "translate(-154.83 -222.21)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.26,388.45c.14.28.18.66-.12.81s-.69-.09-.9-.41c-.06-.09-.05-.23,0-.46C257.67,387.89,258,388,258.26,388.45Z",
    transform: "translate(-154.83 -222.21)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.77,378.81c-.64-.55-.71-.75-.4-1a.55.55,0,0,1,.78,0l0,0C387.55,378.24,387.35,378.58,386.77,378.81Z",
    transform: "translate(-154.83 -222.21)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.67,307.94a.76.76,0,0,1,0,.3c-.08.16-.12.22-.17.25a.6.6,0,0,1-.85-.06l-.09-.14a.66.66,0,0,1,.27-.88l.1,0C218.34,307.25,218.58,307.52,218.67,307.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.08,368.16c-.28-.41-.13-.69.66-1,.45.46.5.84,0,1.14a.45.45,0,0,1-.63-.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.44,400a.57.57,0,0,1-.6.54h0a.7.7,0,0,1-.68-.51.63.63,0,0,1,.36-.75.68.68,0,0,1,.78.08A1.17,1.17,0,0,1,350.44,400Z",
    transform: "translate(-154.83 -222.21)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249,336c.11-.44.45-.53.93-.28.08.8,0,1-.44.92S248.92,336.38,249,336Z",
    transform: "translate(-154.83 -222.21)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.1,348.32c-.55.18-.78-.14-.75-.78.74-.38,1-.36,1.06,0S274.44,348.22,274.1,348.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.62,395.4c0-.41.17-.7.63-.7a1,1,0,0,1,.43.2c.12.26.21.46.16.6a.65.65,0,0,1-.79.47l-.06,0A.51.51,0,0,1,348.62,395.4Z",
    transform: "translate(-154.83 -222.21)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.79,421.87c-.31.2-.57,0-.74-.24a.86.86,0,0,1,0-.45c.08-.15.12-.2.17-.23.28-.18.57-.21.75.12A.58.58,0,0,1,347.79,421.87Z",
    transform: "translate(-154.83 -222.21)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.15,402.2a.63.63,0,0,1,1.2-.28.69.69,0,0,1-.06.8,1.32,1.32,0,0,1-.65.14.54.54,0,0,1-.5-.58S358.15,402.23,358.15,402.2Z",
    transform: "translate(-154.83 -222.21)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.82,475.44a1.07,1.07,0,0,1-.14.63.63.63,0,0,1-.84.17.6.6,0,0,1-.22-.67.56.56,0,0,1,.63-.49h0A1,1,0,0,1,274.82,475.44Z",
    transform: "translate(-154.83 -222.21)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.33,336.4c.3.22.24.55.08.83-.26.44-.58.37-1.08-.38C332.53,336.18,332.89,336.08,333.33,336.4Z",
    transform: "translate(-154.83 -222.21)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365,336.76a.77.77,0,0,1,.23-1,.6.6,0,0,1,.81.22,1,1,0,0,1,.09.62,1.23,1.23,0,0,1-.35.33.54.54,0,0,1-.74-.11Z",
    transform: "translate(-154.83 -222.21)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306,288.38c-.39-.33-.24-.65.08-.94a1.23,1.23,0,0,1,.28-.1c.17,0,.24,0,.28.07a.58.58,0,0,1,.14.81.62.62,0,0,1-.14.14A.5.5,0,0,1,306,288.38Z",
    transform: "translate(-154.83 -222.21)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.59,366.71a.61.61,0,0,1,.08.3.59.59,0,0,1-.62.57l-.16,0a.76.76,0,0,1-.47-.95s0,0,0-.05c.26-.38.62-.31,1-.06A.8.8,0,0,1,214.59,366.71Z",
    transform: "translate(-154.83 -222.21)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216,367.5c-.16-.83.09-1.11.92-1a.88.88,0,0,1,.52.31h0l.1-.09c.41.23.58.52.49.84a1.13,1.13,0,0,0,.58,1.42,1,1,0,0,1,.28.25,1.18,1.18,0,0,1,.15,1.39,1.08,1.08,0,0,1-1.1.56,1.24,1.24,0,0,1-1.2-.72,4.93,4.93,0,0,1-.22-2.38l-.21-.12C216.12,367.71,216,367.63,216,367.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.2,413c.34-.08.49-.07.54.18a3.62,3.62,0,0,1-.46-.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.2,413Z",
    transform: "translate(-154.83 -222.21)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.37,382a.41.41,0,0,1-.05.59l-.06,0c-.42.24-.67,0-.82-.38a.66.66,0,0,1,0-.28C212.83,381.54,213.13,381.63,213.37,382Z",
    transform: "translate(-154.83 -222.21)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.2,386.43a1.62,1.62,0,0,1-.21.8.46.46,0,0,1-.66,0h0a.68.68,0,0,1-.09-1l0,0C222.62,385.91,222.94,385.88,223.2,386.43Z",
    transform: "translate(-154.83 -222.21)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.32,494.88a.56.56,0,0,1-.78.14h0c-.32-.24-.15-.54,0-.81a1,1,0,0,1,.19-.21c.21,0,.35-.08.44,0a.56.56,0,0,1,.27.74A.78.78,0,0,1,227.32,494.88Z",
    transform: "translate(-154.83 -222.21)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.29,423.11a.52.52,0,0,1,.2-.64.67.67,0,0,1,1,0,.08.08,0,0,1,0,0c.3.38.1.69-.32,1C319.7,423.54,319.43,423.44,319.29,423.11Z",
    transform: "translate(-154.83 -222.21)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.05,364.63a.67.67,0,0,1,.82-.45l.07,0c.34.17.35.44-.09,1.13C329.09,365.21,328.91,365,329.05,364.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.91,425.15a.63.63,0,0,1-.64.53c-.15,0-.31-.14-.5-.32a1.06,1.06,0,0,1,.13-.58.59.59,0,0,1,.82-.1A.42.42,0,0,1,283.91,425.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.2,377.8a1,1,0,0,1,.31.12,1.75,1.75,0,0,1,.65,1.57,1.17,1.17,0,0,1-.19.68,2.41,2.41,0,0,1-1.29.65.84.84,0,0,1-1.07-.31h0v.09a4.5,4.5,0,0,1-.94-.31l-.19.12a.76.76,0,0,1-.72,0v-.06l-.07.33a.71.71,0,0,1-.95-.29.69.69,0,0,1-.05-.13h0l-.16.12a1.13,1.13,0,0,1-.26-.93,1.08,1.08,0,0,1,.8-1.09c.46-.15.94-.17,1.18.42a.3.3,0,0,0,.19,0,1.14,1.14,0,0,1,.52,0v-.13a.23.23,0,0,1,.23-.18l-.1-.12a1.63,1.63,0,0,1,1.08-.8A.69.69,0,0,1,246.2,377.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.43,438.07c0-.16.14-.31.33-.51a.9.9,0,0,1,.46,0,.56.56,0,0,1,.34.73v0a.47.47,0,0,1-.56.35h0A.61.61,0,0,1,345.43,438.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.74,334.7a.65.65,0,0,1-.88-.21l-.06-.12a.94.94,0,0,1,0-.47c.67-.42.9-.41,1.1,0a.57.57,0,0,1-.15.79Z",
    transform: "translate(-154.83 -222.21)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.2,309.91c-.27.38-.55.44-.84.25a.85.85,0,0,1-.33-.4.48.48,0,0,1,.22-.61.7.7,0,0,1,.51,0C210.12,309.19,210.2,309.47,210.2,309.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.72,457.29c-.47.22-.82.19-1-.25a.57.57,0,0,1,.38-.7h0C255.59,456.17,255.8,456.45,255.72,457.29Z",
    transform: "translate(-154.83 -222.21)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.71,363c-.15-.44.09-.7.46-.84a.48.48,0,0,1,.62.22.61.61,0,0,1-.16.82,1,1,0,0,1-.6.13C364.85,363.23,364.74,363.14,364.71,363Z",
    transform: "translate(-154.83 -222.21)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.34,332.53c.72.15.86.34.72.72a.61.61,0,0,1-.74.44l-.12,0c-.37-.26-.34-.59-.09-.93A1,1,0,0,1,357.34,332.53Z",
    transform: "translate(-154.83 -222.21)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.88,275.46a.47.47,0,0,1-.31.11c-.34,0-.42-.37-.29-1.06a.89.89,0,0,1,.23-.17C255.2,274.94,255.2,275.09,254.88,275.46Z",
    transform: "translate(-154.83 -222.21)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.2,329.24c.26-.45.59-.41,1.1.24a1.34,1.34,0,0,1-.37.54.48.48,0,0,1-.66-.1h0A.54.54,0,0,1,360.2,329.24Z",
    transform: "translate(-154.83 -222.21)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.48,409.25a.57.57,0,0,1-.72.36h0c-.46-.19-.4-.55-.19-.9a.79.79,0,0,1,.22-.19.72.72,0,0,1,.29-.06C372.48,408.56,372.69,408.83,372.48,409.25Z",
    transform: "translate(-154.83 -222.21)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.63,290.63a.58.58,0,0,1-.06.82c-.28.25-.55,0-.79-.13a1,1,0,0,1-.27-.37.68.68,0,0,1,.19-.41.58.58,0,0,1,.81-.07A.61.61,0,0,1,180.63,290.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.88,407.16c-.1-.26,0-.47.3-.7.37-.08.58,0,.69.28a.5.5,0,0,1-.14.7l-.11.06a.53.53,0,0,1-.7-.23A.49.49,0,0,1,182.88,407.16Z",
    transform: "translate(-154.83 -222.21)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.53,335a.92.92,0,0,1-.06-.46c.19-.19.35-.33.51-.34a.59.59,0,0,1,.64.54.5.5,0,0,1-.34.58C298.94,335.5,298.7,335.31,298.53,335Z",
    transform: "translate(-154.83 -222.21)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.4,367.16a.57.57,0,0,1,.65.27c.24.34.09.62-.49,1h-.3c-.39-.28-.45-.57-.26-.87A.86.86,0,0,1,314.4,367.16Z",
    transform: "translate(-154.83 -222.21)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.2,360.28a.68.68,0,0,1,.53.8v0a.83.83,0,0,1-.35.39c-.33.18-.58,0-.85-.37C369.63,360.36,369.81,360.18,370.2,360.28Z",
    transform: "translate(-154.83 -222.21)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.89,361.15c0-.26.2-.45.57-.54a1.17,1.17,0,0,1,.51.4.48.48,0,0,1-.08.67.62.62,0,0,1-.49.15A.63.63,0,0,1,304.89,361.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.82,464.56c-.3-.51-.05-.89.75-.91.19.39.23.68,0,1a.48.48,0,0,1-.69,0Z",
    transform: "translate(-154.83 -222.21)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.26,443.91a1.56,1.56,0,0,1,.23-.62,1.23,1.23,0,0,1,.61-.23c.21,0,.39.12.35.34a1,1,0,0,1-.85.87C277.38,444.3,277.26,444.11,277.26,443.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.35,421.25c-.47,0-.58-.32-.56-.83.67-.29,1-.22,1,.15S277.71,421.21,277.35,421.25Z",
    transform: "translate(-154.83 -222.21)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.71,436.5a.93.93,0,0,1-.84,1,.34.34,0,0,1-.35-.33c0-.42.22-.66.66-.88C263.44,436.33,263.7,436.41,263.71,436.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171,296.44a.51.51,0,0,1-.62-.36.44.44,0,0,1,0-.1c-.08-.37.14-.5.93-.43C171.57,296.05,171.44,296.35,171,296.44Z",
    transform: "translate(-154.83 -222.21)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.49,354.39c-.26.09-.42-.16-.43-.56a5.87,5.87,0,0,1,1-.93,1.65,1.65,0,0,1,.26.14C339.2,353.58,339.09,354.17,338.49,354.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.46,365.63a.6.6,0,0,1,.48-.12.58.58,0,0,1,.36.36c.13.31,0,.59-.35.85C337.2,366.24,337.11,366,337.46,365.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.92,370.72a.86.86,0,0,1,1.18.34.92.92,0,0,1,.09.23.38.38,0,0,1-.34.43h-.13a2.52,2.52,0,0,1-.76-.4C369.89,371.06,369.83,370.79,369.92,370.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.2,343.9a1.11,1.11,0,0,1,.14.62.41.41,0,0,1-.43.4h-.1a.76.76,0,0,1-.38-.37C213.2,344.12,213.42,344,214.2,343.9Z",
    transform: "translate(-154.83 -222.21)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.2,444.79c.17-.34.46-.34,1.1.09-.39.68-.64.8-.94.56a.48.48,0,0,1-.16-.65Z",
    transform: "translate(-154.83 -222.21)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251,370.25a1.82,1.82,0,0,1-.15.27c-.67.26-.88,0-.89-.55a.5.5,0,0,1,.43-.55h.14C251,369.49,251.08,369.84,251,370.25Z",
    transform: "translate(-154.83 -222.21)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.83,363.73a.39.39,0,0,1,.21.51.27.27,0,0,1-.06.1c-.31.42-.67.45-1.06-.09C348,363.53,348.4,363.53,348.83,363.73Z",
    transform: "translate(-154.83 -222.21)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.2,333.63a.68.68,0,0,1,.46.23c.4.45.15.8-.73.83a1.17,1.17,0,0,1-.18-.6C307.82,333.83,308,333.63,308.2,333.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.87,385.63c.56.09.6.49.37,1-.67.22-.84-.13-.84-.6A.44.44,0,0,1,323.87,385.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.91,401.12a.56.56,0,0,1-.65-.25.56.56,0,0,1,.12-.77l.07,0a.86.86,0,0,1,.63,0,1,1,0,0,1,.17.45A.5.5,0,0,1,322.91,401.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.75,426.52c-.05.25-.27.38-.64.41-.34-.18-.46-.37-.4-.63s.25-.57.62-.46a.55.55,0,0,1,.43.65Z",
    transform: "translate(-154.83 -222.21)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.45,312.72c.32-.07.52.18.54.72,0,.06-.05.11-.17.25-.59.25-.81,0-.8-.44A.5.5,0,0,1,298.45,312.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.93,349.63a1.1,1.1,0,0,1,.24-.42c.56-.26.81-.1.82.39a.56.56,0,0,1-.48.62h-.06a.49.49,0,0,1-.53-.45A.76.76,0,0,1,376.93,349.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.51,224a.54.54,0,0,1-.24.72l-.1,0c-.52.13-.64-.22-.56-.76C345,223.58,345.32,223.42,345.51,224Z",
    transform: "translate(-154.83 -222.21)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.2,334.79a.45.45,0,0,1,.62-.16h0a.61.61,0,0,1,.27.77.71.71,0,0,1-.3.32,1.11,1.11,0,0,1-.43-.15.58.58,0,0,1-.17-.79Z",
    transform: "translate(-154.83 -222.21)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.1,486.16a.57.57,0,0,1,0,.68c-.23.31-.5.25-1-.33a1.09,1.09,0,0,1,.38-.49A.47.47,0,0,1,232.1,486.16Z",
    transform: "translate(-154.83 -222.21)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.14,354.32c-.07.28-.33.32-.58.26a1,1,0,0,1-.39-.24c-.07-.37,0-.57.28-.67a.51.51,0,0,1,.65.15A.66.66,0,0,1,232.14,354.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.5,292.07c-.45-.05-.64-.24-.64-.59s.07-.51.36-.53a.61.61,0,0,1,.47.17C157,291.43,157,291.76,156.5,292.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301,411a.59.59,0,0,1,.1.83l-.1.1c-.39.33-.64.12-.77-.44C300.32,411,300.56,410.72,301,411Z",
    transform: "translate(-154.83 -222.21)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.2,339.31h-.3a.57.57,0,0,1-.34-.72.59.59,0,0,1,.1-.17.49.49,0,0,1,.58-.31c.45.16.41.53.3.89A1.34,1.34,0,0,1,286.2,339.31Z",
    transform: "translate(-154.83 -222.21)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.49,299.63c.14.33.08.63-.3.74a1.26,1.26,0,0,1-.63-.11.5.5,0,0,1,.1-.7l0,0C326,299.31,326.36,299.35,326.49,299.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.13,447.41a.56.56,0,0,1-.77-.18l0-.05c-.13-.23-.06-.47.22-.72a1,1,0,0,1,.6.16C286.41,446.9,286.39,447.28,286.13,447.41Z",
    transform: "translate(-154.83 -222.21)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.81,450c-.53.11-.84,0-.79-.5a.56.56,0,0,1,.66-.44.4.4,0,0,1,.18.07C166.37,449.29,166.2,449.63,165.81,450Z",
    transform: "translate(-154.83 -222.21)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.2,351.54a.71.71,0,0,1-.45.87c-.1,0-.24,0-.44-.09a1,1,0,0,1-.14-.27c-.05-.4,0-.74.48-.85a.43.43,0,0,1,.54.28S360.2,351.52,360.2,351.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.62,412.17a.4.4,0,0,1-.51.23l-.1,0a.54.54,0,0,1-.14-.75l0-.05a1.27,1.27,0,0,1,.25-.14C277.73,411.49,277.86,411.77,277.62,412.17Z",
    transform: "translate(-154.83 -222.21)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.2,222.94a.35.35,0,0,1-.34.36h0c-.46,0-.59-.34-.54-.76a.58.58,0,0,1,.13-.26C318.12,222.06,318.2,222.45,318.2,222.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.86,338a.61.61,0,0,1,.08-.84c.26-.3.52-.28.81.14.05.39,0,.64-.23.79a.45.45,0,0,1-.63-.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.87,427.78c.67-.21.86.17.88.63a.4.4,0,0,1-.37.44h-.11C394.66,428.78,394.69,428.34,394.87,427.78Z",
    transform: "translate(-154.83 -222.21)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.07,376.63a.66.66,0,0,1,.25.45.49.49,0,0,1-.44.51c-.3,0-.61.05-.89.06l.06-.09c.18-.33.25-.58.39-.77S338.83,376.4,339.07,376.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.83,392.8a.58.58,0,0,1,.81.14h0c.21.42-.13.64-.5.77a.76.76,0,0,1-.3,0C355.41,393.33,355.41,393,355.83,392.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.47,494.58c.29-.36.59-.43.8-.13a.48.48,0,0,1-.06.67.38.38,0,0,1-.15.09C258.61,495.39,258.39,495.15,258.47,494.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.2,365.75a.5.5,0,0,1-.58.4l-.13,0c-.46-.19-.39-.52,0-.89C367,365.13,367.33,365.24,367.2,365.75Z",
    transform: "translate(-154.83 -222.21)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.66,421.53a.48.48,0,0,1-.12-.67.34.34,0,0,1,.12-.12c.38-.34.66-.23.8.37C280.32,421.63,280.05,421.86,279.66,421.53Z",
    transform: "translate(-154.83 -222.21)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.5,399.54a.55.55,0,0,1,.25-.63.46.46,0,0,1,.63.12v0a1.27,1.27,0,0,1,.1.64C344.89,400,344.6,399.94,344.5,399.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.82,453.08a.4.4,0,0,1,.34,0,.37.37,0,0,1,.2.46.63.63,0,0,1-.7.55.59.59,0,0,1-.17,0C298.26,453.53,298.42,453.24,298.82,453.08Z",
    transform: "translate(-154.83 -222.21)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368,372.46c-.26.1-.47,0-.67-.34,0-.4.18-.53.44-.56a.47.47,0,1,1,.24.9Z",
    transform: "translate(-154.83 -222.21)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.2,421.88c-.25-.11-.25-.39-.2-.64.09-.41.35-.4.91.18C332.8,421.84,332.56,422,332.2,421.88Z",
    transform: "translate(-154.83 -222.21)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.12,417.69a.55.55,0,0,1,.45.21.48.48,0,0,1-.15.64.38.38,0,0,1-.51,0,.92.92,0,0,1-.28-.53C174.81,417.84,175,417.69,175.12,417.69Z",
    transform: "translate(-154.83 -222.21)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.69,377a.65.65,0,0,1,.69.12c.25.23.35.5-.07.8a.77.77,0,0,1-.83-.47A.36.36,0,0,1,261.69,377Z",
    transform: "translate(-154.83 -222.21)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.28,354.25c-.13.25-.57.2-.81-.1s-.15-.56.36-.66C286.2,353.63,286.47,353.9,286.28,354.25Z",
    transform: "translate(-154.83 -222.21)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.39,458.56a.46.46,0,0,1-.12.65.37.37,0,0,1-.18.08c-.39,0-.53-.22-.47-.68C366.92,458.21,367.2,458.22,367.39,458.56Z",
    transform: "translate(-154.83 -222.21)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.52,443.87a.43.43,0,0,1,.56-.22l.07.05a.58.58,0,0,1,.13.81h0a.88.88,0,0,1-.25.16C266.46,444.57,266.29,444.29,266.52,443.87Z",
    transform: "translate(-154.83 -222.21)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.2,401.63a.3.3,0,0,1,.23.22c.07.5-.1.82-.75.71C304.49,402.05,304.55,401.63,305.2,401.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.45,357.52c.69,0,.82.16.73.62a.39.39,0,0,1-.44.35.4.4,0,0,1-.23-.1C381.2,358.18,381.2,357.91,381.45,357.52Z",
    transform: "translate(-154.83 -222.21)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.2,404.32c.35-.27.66-.3.74.35-.24.33-.49.55-.79.28a.39.39,0,0,1-.06-.54A.31.31,0,0,1,285.2,404.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.73,336c0,.28-.13.46-.53.45-.18-.18-.32-.33-.32-.48a.41.41,0,0,1,.32-.47h.11C301.6,335.5,301.73,335.72,301.73,336Z",
    transform: "translate(-154.83 -222.21)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.72,430.71a.89.89,0,0,1-.51.28c-.18-.18-.32-.33-.33-.48a.63.63,0,0,1,.22-.44.57.57,0,0,1,.48,0,.4.4,0,0,1,.2.54A.21.21,0,0,1,184.72,430.71Z",
    transform: "translate(-154.83 -222.21)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171,409.32c-.13.33-.38.44-.77.16a1.22,1.22,0,0,1-.06-.46c.06-.35.26-.56.62-.45S171.07,409,171,409.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.39,445.72c-.37-.08-.42-.41-.29-.71.06-.14.27-.2.51-.27.2.17.36.32.36.46C198,445.54,197.77,445.8,197.39,445.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.88,389.87a.47.47,0,0,1,.62.25h0a1.1,1.1,0,0,1,.2.64H333a.44.44,0,0,1-.44-.44v-.06A.6.6,0,0,1,332.88,389.87Z",
    transform: "translate(-154.83 -222.21)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.84,330a.71.71,0,0,1,0-.29c.53-.57.77-.2,1,.19a.43.43,0,0,1-.15.6l0,0C308.2,330.63,308,330.32,307.84,330Z",
    transform: "translate(-154.83 -222.21)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.72,374.38a1.61,1.61,0,0,1,.46-.26l.07.09a1.61,1.61,0,0,1,.25.42.44.44,0,0,1-.17.6h0a.56.56,0,0,1-.68-.08C337.34,374.89,337.49,374.63,337.72,374.38Z",
    transform: "translate(-154.83 -222.21)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.2,374.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.93,299.45c-.38.11-.57-.14-.64-.48a.85.85,0,0,1,.19-.42c.46-.21.7-.08.76.3A.49.49,0,0,1,322.93,299.45Z",
    transform: "translate(-154.83 -222.21)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.44,283.12a.6.6,0,0,1,.05.3c-.65.39-.83.36-1-.06a.38.38,0,0,1,.06-.5C297.93,282.56,298.2,282.79,298.44,283.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.82,437.58a4.52,4.52,0,0,1-.25.79l.16.1c.36.14.49.34.4.59s-.42.62-.82.47-.44-.61-.18-1.11l-.09-.06a3.35,3.35,0,0,1,0-1,.43.43,0,0,1,.5-.33l0,0A.41.41,0,0,1,258.82,437.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.51,407.38a.43.43,0,0,1,.35,0,.54.54,0,0,1,.27.63c-.06.36-.28.52-.73.27C222.14,407.84,222.2,407.57,222.51,407.38Z",
    transform: "translate(-154.83 -222.21)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.43,416.63a.54.54,0,0,1-.19-.74.5.5,0,0,1,.19-.19c.34-.21.57,0,.65.46C302,416.63,301.78,416.83,301.43,416.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.87,293.15a.52.52,0,0,1,.18.72.47.47,0,0,1-.18.19c-.34.19-.57,0-.67-.45C252.31,293.16,252.52,293,252.87,293.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.11,349.33c.31-.13.63-.1.74.28s-.17.58-.49.62c-.15,0-.32-.13-.52-.34C259.91,349.63,260,349.4,260.11,349.33Z",
    transform: "translate(-154.83 -222.21)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.93,375.63a.52.52,0,0,1-.25.69l-.12,0c-.4.1-.55-.15-.6-.62C258.32,375.3,258.65,375.24,258.93,375.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.58,378.79c0,.23,0,.36-.11.44a.44.44,0,0,1-.63,0h0a.39.39,0,0,1-.13-.48.44.44,0,0,1,.54-.31h0A1.33,1.33,0,0,1,250.58,378.79Z",
    transform: "translate(-154.83 -222.21)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.05,314.15a.46.46,0,0,1,.58-.3.42.42,0,0,1,.17.1c.33.27.19.53-.19.81C261.15,314.71,260.9,314.54,261.05,314.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.85,420.2c0-.59.32-.78.74-.55a.47.47,0,0,1,.19.64h0C263.51,420.74,263.2,420.63,262.85,420.2Z",
    transform: "translate(-154.83 -222.21)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.38,461.72c0-.14.14-.31.34-.51.27.08.47.14.56.28a.45.45,0,0,1-.18.61l0,0a.48.48,0,0,1-.63-.21A.45.45,0,0,1,360.38,461.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.51,417.16a.44.44,0,0,1-.6-.12s0,0,0,0c-.22-.42,0-.67.54-.75C319.87,416.63,319.91,416.91,319.51,417.16Z",
    transform: "translate(-154.83 -222.21)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388,358.05a.49.49,0,0,1,.18-.66l.15-.05c.37-.11.53.15.57.59C388.6,358.38,388.2,358.45,388,358.05Z",
    transform: "translate(-154.83 -222.21)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.55,419.39a.58.58,0,0,1-.22-.27.44.44,0,0,1,.23-.58l.05,0a.94.94,0,0,1,.7,0,2.57,2.57,0,0,1-.13.66.46.46,0,0,1-.61.22Z",
    transform: "translate(-154.83 -222.21)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.59,392.75a.37.37,0,0,1,.48.13.46.46,0,0,1,0,.65.71.71,0,0,1-.42.14c-.19-.13-.28-.22-.32-.33A.47.47,0,0,1,317.59,392.75Z",
    transform: "translate(-154.83 -222.21)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.63,512.2c-.1.57-.35.77-.79.49a.37.37,0,0,1-.12-.5C229.94,511.74,230.2,511.74,230.63,512.2Z",
    transform: "translate(-154.83 -222.21)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.58,302.24c0-.46.32-.59.83-.39.23.52.1.81-.36.83a.44.44,0,0,1-.47-.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.71,363.9a.44.44,0,0,1,.59-.19l.05,0c.4.24.4.55-.08.9C300.74,364.56,300.48,364.33,300.71,363.9Z",
    transform: "translate(-154.83 -222.21)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.09,366.63a3.1,3.1,0,0,1-.68-.1.46.46,0,0,1-.29-.58h0a.47.47,0,0,1,.39-.35.49.49,0,0,1,.58.33A1,1,0,0,1,399.09,366.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.14,325.09c-.07.27-.14.49-.28.54a.48.48,0,0,1-.63-.21.61.61,0,0,1-.05-.18.46.46,0,0,1,.42-.5h0C316.78,324.74,316.94,324.88,317.14,325.09Z",
    transform: "translate(-154.83 -222.21)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.94,341.77a.86.86,0,0,1-.12-.44c.13-.19.21-.29.31-.32a.46.46,0,0,1,.59.24.41.41,0,0,1-.11.58l0,0a.45.45,0,0,1-.63-.09Z",
    transform: "translate(-154.83 -222.21)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400,366.82a.45.45,0,0,1,.23.61v0a.52.52,0,0,1-.28.22.46.46,0,0,1-.57-.31v0a4.65,4.65,0,0,1-.16-.72h.12A3.31,3.31,0,0,1,400,366.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.2,366.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.56,288a.44.44,0,0,1,.59-.19h0a.46.46,0,0,1,.24.6.48.48,0,0,1-.6.31.56.56,0,0,1-.17-.09.45.45,0,0,1-.09-.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.82,406.94a.46.46,0,0,1,0,.66.54.54,0,0,1-.16.1c-.41.16-.53-.15-.6-.58C224.3,406.7,224.56,406.63,224.82,406.94Z",
    transform: "translate(-154.83 -222.21)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.47,413.25c-.53.2-.82.09-.79-.42a.36.36,0,0,1,.36-.35C165.53,412.45,165.69,412.71,165.47,413.25Z",
    transform: "translate(-154.83 -222.21)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.81,311.34c-.57-.06-.75-.33-.54-.74a.43.43,0,0,1,.58-.2l0,0C385.29,310.63,385.26,311,384.81,311.34Z",
    transform: "translate(-154.83 -222.21)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.45,423.74a.4.4,0,0,1,.42-.38l.1,0c.38.08.42.36.24.78C408.69,424.35,408.39,424.25,408.45,423.74Z",
    transform: "translate(-154.83 -222.21)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.81,395.48c-.43.22-.7.15-.78-.24a.47.47,0,0,1,.31-.56.41.41,0,0,1,.22,0C166,394.76,166,395.05,165.81,395.48Z",
    transform: "translate(-154.83 -222.21)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.2,406.34c0-.11.13-.2.32-.34a.76.76,0,0,1,.53.27.44.44,0,0,1-.16.6l0,0a.53.53,0,0,1-.35,0,.44.44,0,0,1-.31-.53Z",
    transform: "translate(-154.83 -222.21)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.12,263a.47.47,0,0,1-.2.63l-.16,0a.47.47,0,0,1-.48-.44h0c0-.16.13-.32.32-.52C263.86,262.81,264.06,262.89,264.12,263Z",
    transform: "translate(-154.83 -222.21)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.2,469.49c.12-.19.21-.3.31-.33a.46.46,0,0,1,.58.29v0a.42.42,0,0,1-.12.5.44.44,0,0,1-.63,0l0,0A.82.82,0,0,1,245.2,469.49Z",
    transform: "translate(-154.83 -222.21)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202,414.72a.45.45,0,0,1,.59.25s0,0,0,0a.42.42,0,0,1-.15.5.44.44,0,0,1-.62,0s0,0,0,0-.11-.21-.13-.45C201.84,414.86,201.93,414.76,202,414.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.93,372c0,.13.08.26.13.39a.23.23,0,0,1,.09-.08c.49-.07.71.08.69.43a.54.54,0,0,1-.26.4c-.38.14-.48-.16-.56-.53a.35.35,0,0,1-.14.06,1.08,1.08,0,0,1-.5-.06.51.51,0,0,1-.43-.51.45.45,0,0,1,.43-.49h0A.54.54,0,0,1,210.93,372Z",
    transform: "translate(-154.83 -222.21)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.1,454.73c.35-.5.66-.5.92-.09a.45.45,0,0,1-.15.63h0C273.4,455.55,273.2,455.25,273.1,454.73Z",
    transform: "translate(-154.83 -222.21)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.78,309.35c-.45.27-.69.14-.76-.23a.46.46,0,0,1,.52-.58C275.82,308.62,276,308.91,275.78,309.35Z",
    transform: "translate(-154.83 -222.21)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.33,402.44c-.38.48-.68.43-.88,0a.42.42,0,0,1,.17-.56l.09,0C347.11,401.71,347.2,402,347.33,402.44Z",
    transform: "translate(-154.83 -222.21)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.55,353c-.39.16-.54-.13-.57-.59.26-.39.53-.54.77-.18a.48.48,0,0,1,0,.68A.51.51,0,0,1,278.55,353Z",
    transform: "translate(-154.83 -222.21)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.2,390.63a.47.47,0,0,1,.65-.05.41.41,0,0,1,.1.13c.08.12,0,.34-.07.6-.26.08-.47.14-.59.06a.45.45,0,0,1-.21-.59A.44.44,0,0,1,346.2,390.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.27,320.23a.46.46,0,0,1,.44.5.41.41,0,0,1,0,.18c-.06.14-.28.22-.55.28-.2-.19-.34-.36-.34-.52a.46.46,0,0,1,.46-.45Z",
    transform: "translate(-154.83 -222.21)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.08,383.25",
    transform: "translate(-154.83 -222.21)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.92,384.06a.67.67,0,0,1-.44.26.64.64,0,0,1-.39-.33.44.44,0,0,1,.2-.58l.07,0a3.66,3.66,0,0,1,.72-.14v.13A2.32,2.32,0,0,1,346.92,384.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.69,451.9a.4.4,0,0,1,.11.57l-.06.07c-.26.3-.53.18-.8-.18C345,451.79,345.28,451.63,345.69,451.9Z",
    transform: "translate(-154.83 -222.21)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.34,365.91c.23-.46.54-.44.91,0-.1.57-.35.77-.78.49A.38.38,0,0,1,393.34,365.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.81,386.17c-.33.15-.58,0-.73-.33s0-.46.35-.66c.29.06.5.11.59.24a.48.48,0,0,1-.07.67Z",
    transform: "translate(-154.83 -222.21)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.38,444.32c-.52-.1-.78-.33-.47-.77a.42.42,0,0,1,.58-.13l.07.06C189.88,443.76,189.71,444,189.38,444.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.15,426.26a.89.89,0,0,1-.48-.08l-.17.14c-.45.35-.8.3-1-.07a.74.74,0,0,1,.08-1c.36-.32.68-.09,1.09.22v-.1l.33-.09c.35,0,.65,0,.7.42S341.49,426.23,341.15,426.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.36,453.5c-.11-.47.25-.61.68-.79.17.07.29.17.29.27a.73.73,0,0,1-.58.79.32.32,0,0,1-.38-.22S340.36,453.52,340.36,453.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.08,396.32c.52-.22.83-.11.87.36a.44.44,0,0,1-.43.45h0C187,397.11,186.85,396.86,187.08,396.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.78,452.43a.37.37,0,0,1,.11-.51.31.31,0,0,1,.12-.05c.36-.12.51.17.62.57C361.28,452.88,361,452.84,360.78,452.43Z",
    transform: "translate(-154.83 -222.21)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.77,405.73c-.09-.2-.13-.34-.08-.43a.47.47,0,0,1,.58-.32.43.43,0,0,1,.24.24c.11.29,0,.47-.3.57C218.11,405.84,218,405.8,217.77,405.73Z",
    transform: "translate(-154.83 -222.21)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.31,326.25c.18.35,0,.55-.47.6-.37-.27-.44-.55-.13-.78a.4.4,0,0,1,.56.1A.2.2,0,0,1,379.31,326.25Z",
    transform: "translate(-154.83 -222.21)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.86,354.93c.14.23.11.46-.23.67-.25-.08-.45-.15-.51-.29a.39.39,0,0,1,.16-.53l.11,0A.39.39,0,0,1,228.86,354.93Z",
    transform: "translate(-154.83 -222.21)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.63,288.07a.41.41,0,0,1-.1.57l-.1.05a.35.35,0,0,1-.47-.15h0a1.09,1.09,0,0,1,0-.62C229.29,287.72,229.5,287.82,229.63,288.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.82,405.37c-.27.29-.54.16-.8-.21,0-.46.19-.7.58-.52a.45.45,0,0,1,.3.57A.35.35,0,0,1,233.82,405.37Z",
    transform: "translate(-154.83 -222.21)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362,440.29a.88.88,0,0,1,.51-.31c.41.28.37.54.09.76a.41.41,0,0,1-.49,0A.36.36,0,0,1,362,440.29Z",
    transform: "translate(-154.83 -222.21)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.29,341.1c.28-.33.54-.47.77-.15a.4.4,0,0,1-.11.55l-.07,0C248.56,341.69,248.32,341.58,248.29,341.1Z",
    transform: "translate(-154.83 -222.21)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.71,434.75a.37.37,0,0,1,.51.13.36.36,0,0,1,0,.11c.11.37-.19.5-.58.61C275.2,435.24,275.3,435,275.71,434.75Z",
    transform: "translate(-154.83 -222.21)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393,426.4a.44.44,0,0,1,.12-.26c.43-.17.7-.07.74.31a.48.48,0,0,1-.23.42C393.2,427,393.06,426.74,393,426.4Z",
    transform: "translate(-154.83 -222.21)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.2,450.21a.43.43,0,0,1,.06-.61l.06,0c.23-.16.46-.12.68.21a.8.8,0,0,1-.17.43C279.61,450.39,279.37,450.49,279.2,450.21Z",
    transform: "translate(-154.83 -222.21)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.94,454.39c0-.39.3-.48.73-.3.18.44.06.71-.3.76a.4.4,0,0,1-.43-.37Z",
    transform: "translate(-154.83 -222.21)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285,420.63a.38.38,0,0,1-.13.52l-.13.05a.43.43,0,0,1-.46-.21c-.15-.23-.14-.46.21-.66A1.25,1.25,0,0,1,285,420.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.45,257.63c-.51,0-.63-.25-.45-.6a.43.43,0,0,1,.56-.24l.06,0C285.93,257.08,285.83,257.37,285.45,257.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.2,482.27c-.14.21-.27.36-.42.37s-.5-.07-.51-.36.27-.37.5-.36S197,482.07,197.2,482.27Z",
    transform: "translate(-154.83 -222.21)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.45,434.7c.39.05.42.34.2.75-.42.23-.69.19-.74-.21a.46.46,0,0,1,.36-.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.44,432.21c-.42,0-.38-.37-.22-.77.41-.2.72-.19.76.22a.47.47,0,0,1-.37.55A.49.49,0,0,1,296.44,432.21Z",
    transform: "translate(-154.83 -222.21)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.54,304a.4.4,0,0,1-.58.41c-.37-.2-.54-.47,0-.84C184.32,303.63,184.51,303.73,184.54,304Z",
    transform: "translate(-154.83 -222.21)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.05,386.52a.43.43,0,0,1-.4.46h-.06c-.38,0-.49-.29-.27-.73C335.76,386,336,386.14,336.05,386.52Z",
    transform: "translate(-154.83 -222.21)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.67,372c-.33.18-.56.11-.69-.11a.57.57,0,0,1,0-.48.44.44,0,0,1,.61-.12h0C299.8,371.42,299.83,371.63,299.67,372Z",
    transform: "translate(-154.83 -222.21)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.49,444.63a.41.41,0,0,1,.58,0,.22.22,0,0,1,.05.08c.14.35-.11.57-.53.67C334.2,445.15,334.2,444.86,334.49,444.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.53,445.14a.49.49,0,0,1,0,.69l-.12.08c-.37.12-.59-.06-.61-.55C300,445,300.26,444.8,300.53,445.14Z",
    transform: "translate(-154.83 -222.21)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.46,281.72a.43.43,0,0,1-.59-.16l0-.06c-.2-.36,0-.57.47-.61C301.68,281.19,301.77,281.49,301.46,281.72Z",
    transform: "translate(-154.83 -222.21)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.35,271.05a.41.41,0,0,1,.54.21.14.14,0,0,1,0,.09.73.73,0,0,1-.1.45c-.26.18-.45.17-.58,0A.45.45,0,0,1,303.35,271.05Z",
    transform: "translate(-154.83 -222.21)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.61,325.48c-.23-.44-.15-.7.25-.73a.43.43,0,0,1,.45.41v.06C307.29,325.63,307.05,325.73,306.61,325.48Z",
    transform: "translate(-154.83 -222.21)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.06,281.26a.45.45,0,0,1,.59-.24h0a.39.39,0,0,1,.21.52l0,.08a.85.85,0,0,1-.52.27C325,281.7,324.91,281.48,325.06,281.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.66,406.06c-.21.31-.48.29-.75-.1.07-.45.28-.68.62-.53a.41.41,0,0,1,.17.57A.21.21,0,0,1,324.66,406.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.39,280.63a.47.47,0,0,1-.46-.46h0c0-.42.31-.46.73-.27C401.84,280.29,401.82,280.63,401.39,280.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.85,431.85c.37.29.51.57.15.81a.45.45,0,0,1-.61-.13l0-.06C323.2,432.13,323.34,431.88,323.85,431.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.31,380.51a.45.45,0,0,1-.6.2l-.07,0a.73.73,0,0,1,0-.58.4.4,0,0,1,.67.42Z",
    transform: "translate(-154.83 -222.21)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.2,318a.47.47,0,0,1,.63-.23l.07.05a.91.91,0,0,1,0,.61.38.38,0,0,1-.51.16.27.27,0,0,1-.12-.09A.37.37,0,0,1,315.2,318Z",
    transform: "translate(-154.83 -222.21)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.79,325.85a.4.4,0,0,1-.51.23l-.1-.05a.46.46,0,0,1-.12-.64h0c.13-.23.37-.29.71-.13A1,1,0,0,1,318.79,325.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.32,429.8c.15-.21.4-.29.59-.06a.54.54,0,0,1,0,.48c-.1.23-.33.31-.67.14A.77.77,0,0,1,318.32,429.8Z",
    transform: "translate(-154.83 -222.21)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.36,415.58a.74.74,0,0,1-.44.08.46.46,0,0,1-.3-.58h0a.38.38,0,0,1,.23-.25c.29-.1.46.09.57.32S320.44,415.38,320.36,415.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.56,424a.71.71,0,0,1,.57,0,.86.86,0,0,1,0,.59.44.44,0,0,1-.61.16h0C356.28,424.63,356.28,424.21,356.56,424Z",
    transform: "translate(-154.83 -222.21)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.62,366.46c0-.51.29-.63.63-.49a.42.42,0,0,1,.22.56l0,.08C359.2,367,358.91,366.82,358.62,366.46Z",
    transform: "translate(-154.83 -222.21)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.87,265.76c.4,0,.51.27.26.72-.44.24-.7.15-.73-.26a.42.42,0,0,1,.38-.46Z",
    transform: "translate(-154.83 -222.21)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.92,465.42a.45.45,0,0,1,.13-.63h0a.76.76,0,0,1,.59,0c.07.27.12.49,0,.61a.47.47,0,0,1-.65.11Z",
    transform: "translate(-154.83 -222.21)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.05,272.57c-.41.23-.68.19-.73-.2a.44.44,0,0,1,.32-.54.34.34,0,0,1,.2,0C208.2,271.88,208.27,272.16,208.05,272.57Z",
    transform: "translate(-154.83 -222.21)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.7,452.22c.07.19,0,.36-.3.5a.77.77,0,0,1-.44-.14.4.4,0,0,1-.08-.56l.08-.08A.47.47,0,0,1,263.7,452.22Z",
    transform: "translate(-154.83 -222.21)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.2,435.28a2.56,2.56,0,0,1-.27-.64h.12a3.64,3.64,0,0,1,.66,0,.44.44,0,0,1,.3.56h0a.45.45,0,0,1-.81.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.3,291.2c0,.45-.26.64-.79.42a1.06,1.06,0,0,1,0-.61.39.39,0,0,1,.48-.27l.09,0A.57.57,0,0,1,272.3,291.2Z",
    transform: "translate(-154.83 -222.21)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.53,330.39a.44.44,0,0,1-.4.48h0c-.38,0-.46-.33-.29-.76C253.2,329.91,253.5,330,253.53,330.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.27,297.34c0,.25-.17.43-.56.44a.78.78,0,0,1-.29-.5.4.4,0,0,1,.37-.43.11.11,0,0,1,.08,0,.44.44,0,0,1,.4.47Z",
    transform: "translate(-154.83 -222.21)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.63,409.17l.18.12.07.07h0v-.11c.26.23.43.45.23.67v.27c-.29.85-1,1.32-1.3,2.23H290a7.21,7.21,0,0,1,.29,1.38.57.57,0,0,1-.4.56.69.69,0,0,1-.82-.24.72.72,0,0,1-.14-.51c.05-.45-.16-.8-.56-.8-.95,0-1.46-.74-2.18-1.32l-.17.16c-.86,0-1-.53-1.07-1.1a.66.66,0,0,1,.56-.72.63.63,0,0,1,.27,0c.46.12.88.45,1.37.38l.19-.19.1-.1h-.06c.38-.39.72-.83,1.2-.55h.4a1.43,1.43,0,0,0,.54-.13h0C290.2,408.77,290.33,408.73,290.63,409.17Z",
    transform: "translate(-154.83 -222.21)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.9,428.63c-.41-.3-.37-.57-.05-.78a.35.35,0,0,1,.47.14v0C254.53,428.32,254.42,428.55,253.9,428.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.73,293.32a.28.28,0,0,1,.38-.29.39.39,0,0,1,.25.22c.1.36,0,.6-.51.51C371.75,293.56,371.7,293.43,371.73,293.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.51,298.24a1,1,0,0,1,.08-.63c.47-.12.67.09.7.42a.58.58,0,0,1-.22.46C319.83,298.63,319.61,298.48,319.51,298.24Z",
    transform: "translate(-154.83 -222.21)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.94,428.36a.86.86,0,0,0,.05.27c-.07.31-.15.51-.24.82h0c0,.34,0,.67-.34.67v.07c-.06-.05,0,0-.09.1h.12c-.7.38-.75.39-.93-.12a1.51,1.51,0,0,1-.23-.21c-.07-.26-.08-.42-.16-.67h0c-.35-.28-.79-.27-.89-.58l-.24-.17c-.21-.1-.27-.2-.36-.51h0v.15c-.62-.71-.62-.71-1-.26-.08.1-.11.23-.18.32a.73.73,0,0,1-1,.19.78.78,0,0,1-.23-.25,3.13,3.13,0,0,1-.35-.65.89.89,0,0,1,.07-1c.34-.36.66-.12,1,.09s.41.28.62.4.55,0,.71-.29a1.12,1.12,0,0,1,.3-.41l.08-.37c.73-1.28,1.15-1.47,2.41-1.2.88.19,1.1.9,1.21,1.65a3.42,3.42,0,0,1-.08.84h0C302.2,427.7,302.26,428.12,301.94,428.36Z",
    transform: "translate(-154.83 -222.21)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.59,354.63c0-.11.13-.19.31-.29.19.09.29.17.32.28s0,.49-.32.5S387.53,354.84,387.59,354.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.2,422.49c-.06-.26,0-.5.32-.5s.37.24.31.49-.13.19-.32.29C373.37,422.63,373.26,422.63,373.2,422.49Z",
    transform: "translate(-154.83 -222.21)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.2,429a.32.32,0,0,1,.4-.22h0c.25.11.29.36.11.7C322.2,429.55,322.09,429.35,322.2,429Z",
    transform: "translate(-154.83 -222.21)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.76,432.12c-.45-.12-.45-.46-.21-.83l-.17-.15c-.19-.5-.49-.84-.45-1.29a.5.5,0,0,1,.39-.55.49.49,0,0,1,.6.29c.24.55.3,1.16.56,1.74h0l.18.07C331.59,432.11,331.2,432.25,330.76,432.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.79,363.81a.49.49,0,0,1,.18.65c-.22.43-.52.46-.89,0C305.2,363.89,305.31,363.54,305.79,363.81Z",
    transform: "translate(-154.83 -222.21)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.27,353.63c.24-.33.49-.23.72.15-.23.39-.47.5-.72.17A.31.31,0,0,1,318.27,353.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.43,359c-.08-.27,0-.5.32-.51s.4.24.34.51c0,.1-.14.19-.33.28C355.57,359.17,355.45,359.09,355.43,359Z",
    transform: "translate(-154.83 -222.21)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.45,441.13a.48.48,0,0,1-.41.22c-.25-.1-.25-.35-.08-.67C215.44,440.58,215.59,440.78,215.45,441.13Z",
    transform: "translate(-154.83 -222.21)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.2,298.26c.12.35,0,.55-.48.47-.18-.32-.16-.56.08-.67a.29.29,0,0,1,.39.17A0,0,0,0,1,255.2,298.26Z",
    transform: "translate(-154.83 -222.21)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.2,267.88a.35.35,0,0,1,0,.5.41.41,0,0,1-.11.07c-.26.1-.41-.1-.44-.47C215.82,267.63,216,267.63,216.2,267.88Z",
    transform: "translate(-154.83 -222.21)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.2,326c-.28.12-.44-.1-.46-.38,0-.06,0-.12.12-.26s.35-.05.41,0S169.49,325.84,169.2,326Z",
    transform: "translate(-154.83 -222.21)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225,238.7c0,.06,0,.12-.13.26a.33.33,0,0,1-.41,0,.38.38,0,0,1,0-.52.31.31,0,0,1,.13-.1C224.85,238.18,225,238.43,225,238.7Z",
    transform: "translate(-154.83 -222.21)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.34,313c0-.1.12-.19.3-.28.18.09.29.17.31.27.06.25,0,.49-.3.49S309.29,313.29,309.34,313Z",
    transform: "translate(-154.83 -222.21)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.73,379.22c-.08.25-.31.33-.64.11-.11-.37,0-.58.29-.58a.35.35,0,0,1,.37.33A.24.24,0,0,1,379.73,379.22Z",
    transform: "translate(-154.83 -222.21)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.82,394.19c-.39,0-.62-.19-.51-.47a.43.43,0,0,1,.57-.21l.07,0C193.2,393.71,193.2,394,192.82,394.19Z",
    transform: "translate(-154.83 -222.21)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.72,445.05c-.27.1-.41-.11-.43-.48.23-.3.46-.34.61-.1a.38.38,0,0,1-.08.53Z",
    transform: "translate(-154.83 -222.21)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.73,334.88c-.08.3-.31.33-.65.16-.12-.4,0-.54.34-.53S212.79,334.63,212.73,334.88Z",
    transform: "translate(-154.83 -222.21)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.07,455.9a.29.29,0,0,1,.37-.3c.21.06.32.3.14.64C352.2,456.36,352.05,456.19,352.07,455.9Z",
    transform: "translate(-154.83 -222.21)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.86,455.82c-.14.24-.37.25-.59-.1,0-.38.15-.6.43-.5a.4.4,0,0,1,.2.53A.25.25,0,0,1,238.86,455.82Z",
    transform: "translate(-154.83 -222.21)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.7,343.57a.32.32,0,0,1-.08.44l-.05,0c-.3.14-.44,0-.48-.42C197.34,343.28,197.55,343.3,197.7,343.57Z",
    transform: "translate(-154.83 -222.21)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.37,330.86a.4.4,0,0,1,.25-.51l.12,0c.3,0,.42.21.32.61C244.73,331.15,244.45,331.13,244.37,330.86Z",
    transform: "translate(-154.83 -222.21)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.44,340.85c-.19,0-.36,0-.48-.31.11-.28.28-.37.47-.31a.43.43,0,0,1,.28.21A.32.32,0,0,1,240.44,340.85Z",
    transform: "translate(-154.83 -222.21)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.7,337a.38.38,0,0,1,.5.17.28.28,0,0,1,0,.13.67.67,0,0,1-.12.43c-.25,0-.46,0-.55-.13a.38.38,0,0,1,0-.54A.21.21,0,0,1,240.7,337Z",
    transform: "translate(-154.83 -222.21)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.68,364.43c.36-.12.55,0,.48.51-.32.18-.56.15-.68-.09a.32.32,0,0,1,.16-.41Z",
    transform: "translate(-154.83 -222.21)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.64,397.18a.39.39,0,0,1,.12.54l-.06.07c-.21.26-.41.11-.64-.17C276.11,397.16,276.28,396.94,276.64,397.18Z",
    transform: "translate(-154.83 -222.21)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.2,278.12c-.25.34-.45.31-.6,0a.32.32,0,0,1,.09-.45l0,0C272,277.55,272.14,277.73,272.2,278.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.2,448.87c.4.22.49.47.18.72a.36.36,0,0,1-.32,0C347.76,449.36,347.83,449.11,348.2,448.87Z",
    transform: "translate(-154.83 -222.21)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.26,390.9a.53.53,0,0,1,.27.7l0,0a.35.35,0,0,1-.28.15c-.4,0-.4-.35-.41-.65v-.34h.12A1.7,1.7,0,0,1,334.26,390.9Z",
    transform: "translate(-154.83 -222.21)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.13,433.63a.39.39,0,0,1-.21-.51.2.2,0,0,1,0-.08c.15-.25.38-.21.61.11C334.55,433.57,334.4,433.77,334.13,433.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.59,412.4c-.15.24-.38.2-.6-.12,0-.37.17-.57.43-.47a.39.39,0,0,1,.22.51Z",
    transform: "translate(-154.83 -222.21)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.31,418.39Z",
    transform: "translate(-154.83 -222.21)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234,417.74a.44.44,0,0,1-.27.57l-.05,0a2,2,0,0,1-.35.06v-.11a1.6,1.6,0,0,1,0-.31c.05-.25.11-.51.44-.47A.35.35,0,0,1,234,417.74Z",
    transform: "translate(-154.83 -222.21)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.87,460.77a.3.3,0,0,1,.36-.23l0,0c.23.11.27.35.1.68C296.91,461.33,296.77,461.13,296.87,460.77Z",
    transform: "translate(-154.83 -222.21)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.2,415.37a.37.37,0,0,1-.49-.17.49.49,0,0,1,0-.11.6.6,0,0,1,.11-.43c.24,0,.46,0,.54.11a.39.39,0,0,1,0,.55Z",
    transform: "translate(-154.83 -222.21)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.3,393.63c-.29-.07-.36-.28-.17-.63.39-.11.56,0,.55.33a.3.3,0,0,1-.29.31Z",
    transform: "translate(-154.83 -222.21)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203,520.9c.11.34,0,.55-.49.46-.17-.32-.16-.56.08-.67a.3.3,0,0,1,.4.16A.43.43,0,0,1,203,520.9Z",
    transform: "translate(-154.83 -222.21)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.42,326.29c-.49.09-.63-.13-.52-.49a.31.31,0,0,1,.37-.24l.05,0C266.57,325.7,266.6,326,266.42,326.29Z",
    transform: "translate(-154.83 -222.21)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,338.32a.39.39,0,0,1,.08-.55l.09,0a.64.64,0,0,1,.26.07c.17.33.17.57-.12.67A.37.37,0,0,1,300,338.32Z",
    transform: "translate(-154.83 -222.21)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.93,402.06c0-.05.07-.09.2-.15.38.06.48.25.4.5a.32.32,0,0,1-.27.14C320,402.52,319.88,402.33,319.93,402.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.26,359.63l-.27-.2h.11a1.81,1.81,0,0,1,.56.12l0,.05A.41.41,0,0,1,309.26,359.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.71,359.63",
    transform: "translate(-154.83 -222.21)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.82,379.06a.69.69,0,0,1,.19.19c-.06.53-.24.83-.68.75s-.43-.37-.42-.69c0-.05,0-.11.11-.25h-.12C269.35,378.43,269.56,378.45,269.82,379.06Z",
    transform: "translate(-154.83 -222.21)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.2,398.58c.36-.1.5,0,.45.32a.2.2,0,0,1-.12.12C423.27,399.08,423.12,399,423.2,398.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.59,316.54a.25.25,0,0,1-.34.09l-.09-.09c-.12-.16,0-.32.21-.44C211.64,316.22,211.71,316.38,211.59,316.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.2,461.69c-.07,0-.2-.13-.21-.21s.13-.29.41-.2C207.53,461.55,207.47,461.71,207.2,461.69Z",
    transform: "translate(-154.83 -222.21)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.31,414.49a.3.3,0,0,1-.23-.22c0-.23.12-.32.42-.22C171.62,414.34,171.53,414.5,171.31,414.49Z",
    transform: "translate(-154.83 -222.21)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.08,314.34a.27.27,0,0,1-.32-.19.24.24,0,0,1,0-.12c0-.2.18-.28.47-.17C330.35,314.14,330.28,314.3,330.08,314.34Z",
    transform: "translate(-154.83 -222.21)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.66,283.24c.29-.12.46-.06.49.15a.27.27,0,0,1-.19.33h-.13C305.62,283.7,305.55,283.52,305.66,283.24Z",
    transform: "translate(-154.83 -222.21)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.54,392.47a.34.34,0,0,1-.29.1c-.24-.14-.24-.34.08-.54C301.6,392.15,301.66,392.31,301.54,392.47Z",
    transform: "translate(-154.83 -222.21)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.82,403.43a.08.08,0,0,1,0,.12h0c-.42.22-.8.41-.83-.27l-.17-.08c.14-.55.4-.83.86-.64a.5.5,0,0,1,.19-.1C296.28,402.82,296.2,403.14,295.82,403.43Z",
    transform: "translate(-154.83 -222.21)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.43,276.7c-.12.28-.28.3-.41.15a.3.3,0,0,1,0-.29C339.15,276.4,339.31,276.41,339.43,276.7Z",
    transform: "translate(-154.83 -222.21)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292,456.12c-.31-.19-.44-.39-.18-.58a.34.34,0,0,1,.31,0C292.33,455.73,292.26,455.94,292,456.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.36,279.63c-.24-.19-.37-.4-.15-.6a.27.27,0,0,1,.3,0C291.72,279.2,291.66,279.4,291.36,279.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.15,312.91a.28.28,0,0,1,.21-.21.28.28,0,0,1,.2.4C321.29,313.21,321.14,313.13,321.15,312.91Z",
    transform: "translate(-154.83 -222.21)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.15,449.23c-.27.07-.41-.06-.32-.42.26-.1.41,0,.45.15A.24.24,0,0,1,321.15,449.23Z",
    transform: "translate(-154.83 -222.21)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.11,466.79c.13-.28.29-.32.44-.16a.34.34,0,0,1,0,.31C318.41,467.1,318.2,467.07,318.11,466.79Z",
    transform: "translate(-154.83 -222.21)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.2,352.05a.29.29,0,0,1,.31,0c.18.15.12.32-.15.46C318.1,352.37,318.06,352.2,318.2,352.05Z",
    transform: "translate(-154.83 -222.21)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318,404.5c.28.12.34.27.22.43a.34.34,0,0,1-.29.1C317.66,404.89,317.64,404.69,318,404.5Z",
    transform: "translate(-154.83 -222.21)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.07,450.4c.14-.17.3-.14.44.15-.13.3-.3.31-.44.16A.29.29,0,0,1,317.07,450.4Z",
    transform: "translate(-154.83 -222.21)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.2,446.11c.26.11.27.26.13.4a.26.26,0,0,1-.27,0C315.88,446.38,315.93,446.24,316.2,446.11Z",
    transform: "translate(-154.83 -222.21)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.78,443.36c0-.35.24-.33.57-.24.1.34.13.59-.22.57A.36.36,0,0,1,315.78,443.36Z",
    transform: "translate(-154.83 -222.21)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.2,420.54c-.27-.13-.31-.3-.15-.45a.32.32,0,0,1,.3,0C314.5,420.23,314.46,420.4,314.2,420.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.7,369.47c-.09-.27,0-.43.15-.46a.34.34,0,0,1,.27.13C357.2,369.42,357.07,369.56,356.7,369.47Z",
    transform: "translate(-154.83 -222.21)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.77,416.63c.37-.15.6-.12.59.23a.32.32,0,0,1-.29.35h0C252.69,417.26,252.64,417,252.77,416.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.29,350.58c.29-.11.43,0,.42.2a.31.31,0,0,1-.21.22C364.29,351,364.2,350.87,364.29,350.58Z",
    transform: "translate(-154.83 -222.21)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.41,386.07c-.14.16-.3.12-.43-.15.13-.28.29-.31.43-.15A.32.32,0,0,1,238.41,386.07Z",
    transform: "translate(-154.83 -222.21)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233,372.38a.3.3,0,0,1,.18.25c.07.33-.15.38-.5.28C232.64,372.53,232.7,372.33,233,372.38Z",
    transform: "translate(-154.83 -222.21)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.83,469.83c-.06-.38.18-.5.64-.34.12.43.1.74-.32.68A.54.54,0,0,1,231.83,469.83Z",
    transform: "translate(-154.83 -222.21)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.55,385.47l.18.11c.8-.12,1.15.57,1.68.6,1,.07,1.06.68,1.12,1.41,0,.3.16.63-.11.88a6.26,6.26,0,0,1-2.33,1.56.7.7,0,0,1-.71-.06c-.46-.43-1-.88-1-1.54a4.79,4.79,0,0,1,.68-2.91l-.09-.06c0-.31,0-.5.22-.55s.33.13.38.31A.43.43,0,0,1,374.55,385.47Z",
    transform: "translate(-154.83 -222.21)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.45,287.92c-.23.19-.42.08-.58-.29.16-.36.36-.5.59-.31a.34.34,0,0,1,.11.48A.34.34,0,0,1,227.45,287.92Z",
    transform: "translate(-154.83 -222.21)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.3,299c.13-.28.29-.32.43-.15a.27.27,0,0,1,0,.3C376.59,299.3,376.43,299.26,376.3,299Z",
    transform: "translate(-154.83 -222.21)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219,409.15l-.28-.08c-.46-.28-.61-.59-.44-1a.67.67,0,0,1,.76-.38.79.79,0,0,1,.71.72,1,1,0,0,1-.15.62h.13v.35h.14a2.08,2.08,0,0,1,.86.06.6.6,0,0,1,.42.75.63.63,0,0,1-.5.44,1.19,1.19,0,0,1-.53,0v.18c0,.51-.09.89.35,1.09a3.35,3.35,0,0,1,.53.19.65.65,0,0,1,.36.84.31.31,0,0,1-.05.1.61.61,0,0,1-.82.22c-.33-.15-.64-.37-1.06-.6v.08c-.26.12-.4.21-.54.18a1.66,1.66,0,0,0-.15-.33h-.14c-.75-.8-.79-1-.15-1.26.45-.23.66-.69,1.22-.93l-.1-.09a3,3,0,0,1,0-.6h-.12A1,1,0,0,1,219,409.15Z",
    transform: "translate(-154.83 -222.21)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.08,360.63a.24.24,0,0,1,.16-.3h.13c.2,0,.27.18.16.44S219.12,360.82,219.08,360.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.84,413v.09c0,.27-.06.5-.26.46s-.15-.25,0-.37A1.51,1.51,0,0,1,218.84,413Z",
    transform: "translate(-154.83 -222.21)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.37,440.21c-.19,0-.26-.18-.16-.44.26-.11.41,0,.45.13a.23.23,0,0,1-.15.3A.22.22,0,0,1,290.37,440.21Z",
    transform: "translate(-154.83 -222.21)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.57,400.63c0,.28-.12.47-.41.44s-.33-.27-.2-.64C283.33,400.22,283.54,400.28,283.57,400.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.68,423.54c.29-.1.44,0,.42.2a.31.31,0,0,1-.21.22C274.67,424,274.58,423.83,274.68,423.54Z",
    transform: "translate(-154.83 -222.21)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.6,406.63c-.3-.18-.39-.38-.16-.57a.34.34,0,0,1,.31,0C355,406.23,354.92,406.43,354.6,406.63Z",
    transform: "translate(-154.83 -222.21)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.77,342.83c0-.21.12-.31.41-.21.09.28,0,.43-.2.42S354.78,342.91,354.77,342.83Z",
    transform: "translate(-154.83 -222.21)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.33,366.12a.56.56,0,0,1-.05.36.22.22,0,0,1-.14-.1A.36.36,0,0,1,316.33,366.12Z",
    transform: "translate(-154.83 -222.21)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.11,440c.22.12.08.23-.12.23C323,440.08,323.08,440,323.11,440Z",
    transform: "translate(-154.83 -222.21)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.82,401.34l.08.16c.14.71-.28,1.17-.42,1.71s-.07-.2-.19-.06c-.39-.56-1-.63-1.61-.86-.39-.17-.58.38-.91.52a.89.89,0,0,1-.36.11.9.9,0,0,1-.94-.48,1.08,1.08,0,0,1,.21-1.22.67.67,0,0,1,.86,0c.27.15.5.38.91.3.15-.38.33-.77.46-1.19a.34.34,0,0,1,.39-.28c.69.06,1.44,0,1.48,1.09h.1C333.89,401.25,333.88,401.31,333.82,401.34Z",
    transform: "translate(-154.83 -222.21)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpill2);
export default __webpack_public_path__ + "static/media/spill-2.64a5fcc18373f27ef1ff8df8be5cc050.svg";
export { ForwardRef as ReactComponent };